// ========================================
// COUPLES BUILDER - NEWSWORTHY EDITION
// The Most Incredible Ring Shopping Experience
// ========================================

// ========================================
// PERSONALIZATION & NAMES SYSTEM
// ========================================

var cjUserNames = {
  name1: '',
  name2: ''
};

// Show names overlay
window.showNamesOverlay = function() {
  console.log('showNamesOverlay called');
  var overlay = document.getElementById('cjNamesOverlay');
  var splash = document.getElementById('cjIntroSplash');
  
  if (overlay) {
    console.log('Found names overlay, showing it');
    overlay.classList.add('active');
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
  } else {
    console.error('Names overlay not found, skipping to builder');
    dismissNamesOverlay();
    return;
  }
  
  if (splash) {
    console.log('Hiding splash');
    splash.classList.add('fade-out');
    setTimeout(function() {
      splash.style.display = 'none';
    }, 500);
  }
};

// Emergency skip - go directly to builder
window.emergencySkip = function() {
  console.log('Emergency skip activated');
  var splash = document.getElementById('cjIntroSplash');
  var overlay = document.getElementById('cjNamesOverlay');
  var builder = document.getElementById('couplesJourney');
  
  if (splash) splash.style.display = 'none';
  if (overlay) { overlay.style.display = 'none'; overlay.classList.remove('active'); }
  if (builder) builder.style.display = 'block';
};

// 🔥🔥🔥 TRILLION DOLLAR NAME ANIMATION - NAMES FLY TO PROGRESS BAR 🔥🔥🔥
window.saveNamesAndContinue = function() {
  console.log('🔥🔥🔥 TRILLION DOLLAR saveNamesAndContinue CALLED! 🔥🔥🔥');
  
  var name1Input = document.getElementById('cjName1Input');
  var name2Input = document.getElementById('cjName2Input');
  
  var name1 = name1Input ? name1Input.value.trim() || 'Partner 1' : 'Partner 1';
  var name2 = name2Input ? name2Input.value.trim() || 'Partner 2' : 'Partner 2';
  
  console.log('Names entered:', name1, '&', name2);
  
  cjUserNames.name1 = name1;
  cjUserNames.name2 = name2;
  
  // 🔥 Make globally accessible IMMEDIATELY
  window.cjUserNames = cjUserNames;
  console.log('🔥 Names saved to window.cjUserNames:', window.cjUserNames);

  // 🔥 CREATE FLYING NAME ELEMENTS
  console.log('Starting flying name animation...');
  createFlyingNameAnimation(name1, name2, function() {
    console.log('Animation complete, dismissing overlay...');
    dismissNamesOverlay();
    personalizeJourney();
  });
};

// 🔥🔥🔥 SIMPLE FLYING NAME ANIMATION 🔥🔥🔥
function createFlyingNameAnimation(name1, name2, callback) {
  console.log('🚀 Flying names:', name1, name2);
  
  // 🔥 Set names in labels FIRST
  var labels = document.querySelectorAll('.cj-progress__label');
  if (labels[1]) labels[1].textContent = name1;
  if (labels[2]) labels[2].textContent = name2;
  
  // 🔥 Get input positions
  var input1 = document.getElementById('cjName1Input');
  var input2 = document.getElementById('cjName2Input');
  
  if (!input1 || !input2) {
    console.log('❌ Inputs not found, skipping animation');
    if (callback) callback();
    return;
  }
  
  var inputRect1 = input1.getBoundingClientRect();
  var inputRect2 = input2.getBoundingClientRect();
  
  // 🔥 Get label positions - these are the TARGET positions
  var label1 = labels[1];
  var label2 = labels[2];
  
  if (!label1 || !label2) {
    console.log('❌ Labels not found, skipping animation');
    if (callback) callback();
    return;
  }
  
  var labelRect1 = label1.getBoundingClientRect();
  var labelRect2 = label2.getBoundingClientRect();
  
  console.log('📍 Input 1:', inputRect1.left, inputRect1.top);
  console.log('📍 Input 2:', inputRect2.left, inputRect2.top);
  console.log('📍 Label 1:', labelRect1.left, labelRect1.top);
  console.log('📍 Label 2:', labelRect2.left, labelRect2.top);
  
  // 🔥 Check if positions are valid (not 0,0)
  if (labelRect1.left < 10 || labelRect1.top < 10 || labelRect2.left < 10) {
    console.log('❌ Invalid label positions, skipping animation');
    if (callback) callback();
    return;
  }
  
  // Target = center of labels
  var targetX1 = labelRect1.left + labelRect1.width / 2;
  var targetY1 = labelRect1.top + labelRect1.height / 2;
  var targetX2 = labelRect2.left + labelRect2.width / 2;
  var targetY2 = labelRect2.top + labelRect2.height / 2;
  
  // Start positions = center of inputs
  var startX1 = inputRect1.left + inputRect1.width / 2;
  var startY1 = inputRect1.top + inputRect1.height / 2;
  var startX2 = inputRect2.left + inputRect2.width / 2;
  var startY2 = inputRect2.top + inputRect2.height / 2;
  
  console.log('✅ Animation will run:');
  console.log('   Name 1:', startX1, startY1, '->', targetX1, targetY1);
  console.log('   Name 2:', startX2, startY2, '->', targetX2, targetY2);
  
  // 🔥 Hide labels during animation
  label1.style.opacity = '0';
  label2.style.opacity = '0';
  
  // 🔥 Create flying name 1
  var fly1 = document.createElement('div');
  fly1.innerHTML = name1;
  fly1.style.cssText = 'position:fixed;z-index:1000000;font-family:Playfair Display,serif;font-size:1rem;font-weight:600;color:#fff;white-space:nowrap;pointer-events:none;text-shadow:0 0 20px rgba(212,165,116,0.8);left:'+startX1+'px;top:'+startY1+'px;transform:translate(-50%,-50%) scale(0);opacity:0;';
  document.body.appendChild(fly1);
  
  // 🔥 Create flying name 2
  var fly2 = document.createElement('div');
  fly2.innerHTML = name2;
  fly2.style.cssText = 'position:fixed;z-index:1000000;font-family:Playfair Display,serif;font-size:1rem;font-weight:600;color:#fff;white-space:nowrap;pointer-events:none;text-shadow:0 0 20px rgba(212,165,116,0.8);left:'+startX2+'px;top:'+startY2+'px;transform:translate(-50%,-50%) scale(0);opacity:0;';
  document.body.appendChild(fly2);
  
  // 🔥 STEP 1: Names POP UP
  setTimeout(function() {
    fly1.style.transition = 'all 0.4s ease-out';
    fly1.style.transform = 'translate(-50%,-50%) scale(1)';
    fly1.style.opacity = '1';
  }, 100);
  setTimeout(function() {
    fly2.style.transition = 'all 0.4s ease-out';
    fly2.style.transform = 'translate(-50%,-50%) scale(1)';
    fly2.style.opacity = '1';
  }, 200);
  
  // 🔥 STEP 2: Names FLY to label positions
  setTimeout(function() {
    fly1.style.transition = 'all 0.8s cubic-bezier(0.4,0,0.2,1)';
    fly1.style.left = targetX1 + 'px';
    fly1.style.top = targetY1 + 'px';
    fly1.style.transform = 'translate(-50%,-50%) scale(0.7)';
    fly1.style.color = '#d4a574';
  }, 500);
  setTimeout(function() {
    fly2.style.transition = 'all 0.8s cubic-bezier(0.4,0,0.2,1)';
    fly2.style.left = targetX2 + 'px';
    fly2.style.top = targetY2 + 'px';
    fly2.style.transform = 'translate(-50%,-50%) scale(0.7)';
    fly2.style.color = '#d4a574';
  }, 600);
  
  // 🔥 STEP 3: Remove flying names, show labels with names
  setTimeout(function() {
    // Remove flying elements
    fly1.remove();
    fly2.remove();
    
    // Show labels (they already have the names set)
    if (label1) {
      label1.style.transition = 'opacity 0.3s ease';
      label1.style.opacity = '1';
    }
    if (label2) {
      label2.style.transition = 'opacity 0.3s ease';
      label2.style.opacity = '1';
    }
    
    // Callback
    if (callback) callback();
  }, 1500);
}

// 🔥 NAME EXPLOSION PARTICLES
function createNameExplosion(x, y) {
  console.log('💥 Creating explosion at:', x, y);
  var colors = ['#B5908A', '#D4C4C1', '#E8D5D2', '#ffffff'];
  
  for (var i = 0; i < 12; i++) {
    (function(index) {
      var particle = document.createElement('div');
      var angle = (index / 12) * Math.PI * 2;
      var velocity = 60 + Math.random() * 60;
      var size = 6 + Math.random() * 10;
      var tx = Math.cos(angle) * velocity;
      var ty = Math.sin(angle) * velocity;
      
      particle.style.cssText = 
        'position:fixed;' +
        'left:' + x + 'px;' +
        'top:' + y + 'px;' +
        'width:' + size + 'px;' +
        'height:' + size + 'px;' +
        'background:' + colors[Math.floor(Math.random() * colors.length)] + ';' +
        'border-radius:50%;' +
        'z-index:999998;' +
        'pointer-events:none;' +
        'box-shadow:0 0 10px currentColor;' +
        'transition:all 0.6s ease-out;' +
        'transform:translate(-50%,-50%) scale(1);' +
        'opacity:1;';
      
      document.body.appendChild(particle);
      
      // Animate outward
      setTimeout(function() {
        particle.style.transform = 'translate(calc(-50% + ' + tx + 'px), calc(-50% + ' + ty + 'px)) scale(0)';
        particle.style.opacity = '0';
      }, 20);
      
      // Remove after animation
      setTimeout(function() {
        if (particle.parentNode) particle.remove();
      }, 700);
    })(i);
  }
}

// Skip names
window.skipNames = function() {
  cjUserNames.name1 = 'Partner 1';
  cjUserNames.name2 = 'Partner 2';
  dismissNamesOverlay();
};

function dismissNamesOverlay() {
  var splash = document.getElementById('cjIntroSplash');
  var overlay = document.getElementById('cjNamesOverlay');
  var builder = document.getElementById('couplesJourney');
  var loveMeter = document.getElementById('cjLoveMeter');
  
  console.log('Dismissing overlays, showing builder...');
  
  // FORCE hide the splash
  if (splash) {
    splash.style.display = 'none';
    splash.style.opacity = '0';
    splash.style.pointerEvents = 'none';
  }
  
  // FORCE hide the names overlay
  if (overlay) {
    overlay.classList.remove('active');
    overlay.style.display = 'none';
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }
  
  // CRITICAL: Show the main builder
  if (builder) {
    builder.style.display = 'block';
    builder.style.opacity = '1';
    console.log('Builder shown successfully!');
  } else {
    console.error('ERROR: Builder element not found!');
    alert('Error: Could not load ring builder. Please refresh the page.');
  }
  
  // Show love meter
  if (loveMeter) {
    loveMeter.classList.add('active');
  }
  
  // Optional celebrations - wrapped in try/catch to prevent blocking
  try {
    if (typeof triggerCelebration === 'function') triggerCelebration('burst');
    if (typeof showMilestone === 'function') showMilestone('Welcome to your journey!');
    if (typeof unlockAchievement === 'function') unlockAchievement('journey-started');
    if (typeof updateLoveMeter === 'function') updateLoveMeter(5);
    if (typeof startFloatingQuotes === 'function') startFloatingQuotes();
    if (typeof startSparkleTrail === 'function') startSparkleTrail();
  } catch(e) {
    console.log('Celebration error (non-critical):', e);
  }
}

function personalizeJourney() {
  console.log('🔥 TRILLION DOLLAR PERSONALIZATION for:', cjUserNames.name1, '&', cjUserNames.name2);
  
  var name1 = cjUserNames.name1 || 'Partner 1';
  var name2 = cjUserNames.name2 || 'Partner 2';
  
  // 🔥🔥🔥 IMMEDIATELY UPDATE PROGRESS BAR WITH EPIC ANIMATION 🔥🔥🔥
  var progressLabels = document.querySelectorAll('.cj-progress__label');
  progressLabels.forEach(function(label, index) {
    if (index === 1) { // Ring 1 step
      // Animate the label change
      label.classList.add('cj-label-updating');
      setTimeout(function() {
        label.innerHTML = "<span class='cj-animated-name cj-name-glow'>" + name1 + "</span>";
        label.classList.remove('cj-label-updating');
        label.classList.add('cj-label-updated');
      }, 200);
    } else if (index === 2) { // Ring 2 step
      label.classList.add('cj-label-updating');
      setTimeout(function() {
        label.innerHTML = "<span class='cj-animated-name cj-name-glow'>" + name2 + "</span>";
        label.classList.remove('cj-label-updating');
        label.classList.add('cj-label-updated');
      }, 400);
    }
  });
  
  // 🔥 UPDATE STEP TITLES
  setTimeout(function() {
    // Step 2 title (Ring 1)
    var step2Title = document.querySelector('.cj-step[data-step="2"] .cj-select__title');
    if (step2Title) {
      animateNameChange(step2Title, "Crafting " + name1 + "'s Ring");
    }
    
    // Step 3 title (Ring 2)
    var step3Title = document.querySelector('.cj-step[data-step="3"] .cj-select__title');
    if (step3Title) {
      animateNameChange(step3Title, "Crafting " + name2 + "'s Ring");
    }
  }, 500);
  
  // 🔥 UPDATE FIELD LABELS
  setTimeout(function() {
    // Ring 1 Style/Size/Engraving labels
    var ring1Labels = document.querySelectorAll('.cj-step[data-step="2"] .cj-field__label');
    ring1Labels.forEach(function(label) {
      var text = label.innerHTML;
      if (text.includes('Ring 1 Style')) {
        label.innerHTML = text.replace('Ring 1 Style', '<span class="cj-animated-name cj-name-sparkle">' + name1 + "'s</span> Style");
      } else if (text.includes('Ring 1 Size')) {
        label.innerHTML = text.replace('Ring 1 Size', '<span class="cj-animated-name cj-name-sparkle">' + name1 + "'s</span> Size");
      } else if (text.includes('Ring 1 Engraving')) {
        label.innerHTML = text.replace('Ring 1 Engraving', '<span class="cj-animated-name cj-name-sparkle">' + name1 + "'s</span> Engraving");
      }
    });
    
    // Ring 2 Style/Size/Engraving labels
    var ring2Labels = document.querySelectorAll('.cj-step[data-step="3"] .cj-field__label');
    ring2Labels.forEach(function(label) {
      var text = label.innerHTML;
      if (text.includes('Ring 2 Style')) {
        label.innerHTML = text.replace('Ring 2 Style', '<span class="cj-animated-name cj-name-sparkle">' + name2 + "'s</span> Style");
      } else if (text.includes('Ring 2 Size')) {
        label.innerHTML = text.replace('Ring 2 Size', '<span class="cj-animated-name cj-name-sparkle">' + name2 + "'s</span> Size");
      } else if (text.includes('Ring 2 Engraving')) {
        label.innerHTML = text.replace('Ring 2 Engraving', '<span class="cj-animated-name cj-name-sparkle">' + name2 + "'s</span> Engraving");
      }
    });
  }, 700);
  
  // 🔥 UPDATE SUMMARY CARD LABELS
  setTimeout(function() {
    var summaryLabels = document.querySelectorAll('.cj-summary-card__label');
    summaryLabels.forEach(function(label, index) {
      if (index === 0) {
        animateNameChange(label, name1 + "'s Ring");
      } else if (index === 1) {
        animateNameChange(label, name2 + "'s Ring");
      }
    });
  }, 900);
  
  // 🔥 UPDATE NAV BUTTON TEXT - PERSONALIZED & PREMIUM (NO EMOJI)
  setTimeout(function() {
    var step1NextBtn = document.getElementById('step1Next');
    if (step1NextBtn) {
      var span = step1NextBtn.querySelector('span');
      if (span) span.innerHTML = "Find <span class='cj-animated-name'>" + name1 + "'s</span> Perfect Ring";
    }

    var step2NextBtn = document.getElementById('step2Next');
    if (step2NextBtn) {
      var span = step2NextBtn.querySelector('span');
      if (span) span.innerHTML = "Continue to <span class='cj-animated-name'>" + name2 + "'s</span> Ring";
    }
    
    var step3NextBtn = document.getElementById('step3Next');
    if (step3NextBtn) {
      var span = step3NextBtn.querySelector('span');
      if (span) span.innerHTML = "Complete " + name1 + " & " + name2 + "'s Set";
    }
  }, 600);
  
  // 🔥 UPDATE PRICING LABELS
  setTimeout(function() {
    var pricingLabels = document.querySelectorAll('.cj-pricing__label');
    pricingLabels.forEach(function(label) {
      if (label.textContent.includes('Ring 1')) {
        var icon = label.querySelector('.cj-pricing-icon');
        label.innerHTML = '';
        if (icon) label.appendChild(icon);
        label.innerHTML += " <span class='cj-animated-name'>" + name1 + "'s Ring</span>";
      } else if (label.textContent.includes('Ring 2')) {
        var icon = label.querySelector('.cj-pricing-icon');
        label.innerHTML = '';
        if (icon) label.appendChild(icon);
        label.innerHTML += " <span class='cj-animated-name'>" + name2 + "'s Ring</span>";
      }
    });
  }, 1000);
  
  // 🔥 UPDATE INFINITY ANIMATION LABELS
  setTimeout(function() {
    var infinityLabels = document.querySelectorAll('.cj-infinity__engraving-label');
    if (infinityLabels[0]) infinityLabels[0].innerHTML = "<span class='cj-animated-name'>" + name1 + "'s Ring</span>";
    if (infinityLabels[1]) infinityLabels[1].innerHTML = "<span class='cj-animated-name'>" + name2 + "'s Ring</span>";
  }, 800);
  
  // 🔥 UPDATE SUMMARY CARD LABELS
  setTimeout(function() {
    var summaryLabels = document.querySelectorAll('.cj-summary-card__label');
    if (summaryLabels[0]) summaryLabels[0].innerHTML = "<span class='cj-animated-name'>" + name1 + "'s Ring</span>";
    if (summaryLabels[1]) summaryLabels[1].innerHTML = "<span class='cj-animated-name'>" + name2 + "'s Ring</span>";
  }, 900);
  
  // 🔥 UPDATE ACHIEVEMENT TEXT
  setTimeout(function() {
    var ring1Achievement = document.querySelector('[data-achievement="ring1-complete"]');
    var ring2Achievement = document.querySelector('[data-achievement="ring2-complete"]');
    if (ring1Achievement) {
      var textNode = ring1Achievement.childNodes[ring1Achievement.childNodes.length - 1];
      if (textNode && textNode.nodeType === 3) textNode.textContent = " " + name1 + "'s Ring Complete!";
    }
    if (ring2Achievement) {
      var textNode = ring2Achievement.childNodes[ring2Achievement.childNodes.length - 1];
      if (textNode && textNode.nodeType === 3) textNode.textContent = " " + name2 + "'s Ring Complete!";
    }
  }, 1000);
  
  // 🔥 UPDATE BACK BUTTON
  setTimeout(function() {
    var backBtns = document.querySelectorAll('.cj-nav__btn--back span');
    backBtns.forEach(function(span) {
      if (span.textContent.includes('Ring 2')) {
        span.textContent = "Back to " + name2 + "'s Ring";
      }
    });
  }, 700);
  
  // 🔥 UPDATE CINEMATIC TRANSITION TEXT
  window.cjUserNames = cjUserNames; // Make globally accessible
}

// 🔥 TRILLION DOLLAR NAME ANIMATION
function animateNameChange(element, newText) {
  if (!element) return;
  
  // Add exit animation
  element.style.transition = 'all 0.3s ease';
  element.style.opacity = '0';
  element.style.transform = 'translateY(-10px)';
  
  setTimeout(function() {
    // Change text
    element.innerHTML = "<span class='cj-animated-name'>" + newText + "</span>";
    
    // Enter animation
    element.style.opacity = '1';
    element.style.transform = 'translateY(0)';
  }, 300);
}

// ========================================
// LOVE METER PROGRESS SYSTEM
// ========================================

var currentLoveProgress = 0;

window.updateLoveMeter = function(progress) {
  currentLoveProgress = Math.min(100, Math.max(0, progress));
  
  var fill = document.getElementById('loveMeterFill');
  var percent = document.getElementById('loveMeterPercent');
  
  if (fill) {
    fill.style.width = currentLoveProgress + '%';
  }
  if (percent) {
    percent.textContent = currentLoveProgress + '%';
  }
  
  // Check for 100% completion
  if (currentLoveProgress >= 100) {
    unlockAchievement('perfect-match');
    triggerCelebration('confetti', 'high');
  }
};

window.addLoveProgress = function(amount) {
  updateLoveMeter(currentLoveProgress + amount);
};

// ========================================
// ACHIEVEMENT SYSTEM
// ========================================

var unlockedAchievements = {};

window.unlockAchievement = function(achievementId) {
  if (unlockedAchievements[achievementId]) return;
  unlockedAchievements[achievementId] = true;
  
  var badge = document.querySelector('[data-achievement="' + achievementId + '"]');
  if (badge) {
    badge.classList.add('unlocked');
    
    // Remove after showing
    setTimeout(function() {
      badge.classList.remove('unlocked');
    }, 4000);
  }
};

// ========================================
// SPARKLE CURSOR TRAIL
// ========================================

var sparkleEnabled = false;
var sparkleThrottle = 0;

function startSparkleTrail() {
  sparkleEnabled = true;
  
  document.addEventListener('mousemove', function(e) {
    if (!sparkleEnabled) return;
    
    var now = Date.now();
    if (now - sparkleThrottle < 50) return;
    sparkleThrottle = now;
    
    createSparkle(e.clientX, e.clientY);
  });
}

function createSparkle(x, y) {
  var sparkle = document.createElement('div');
  sparkle.className = 'cj-sparkle';
  
  // Random type
  var types = ['', '--rose', '--teal', '--white'];
  sparkle.classList.add('cj-sparkle' + types[Math.floor(Math.random() * types.length)]);
  
  sparkle.style.left = (x + (Math.random() - 0.5) * 20) + 'px';
  sparkle.style.top = (y + (Math.random() - 0.5) * 20) + 'px';
  
  document.body.appendChild(sparkle);
  
  setTimeout(function() {
    if (sparkle.parentNode) sparkle.parentNode.removeChild(sparkle);
  }, 800);
}

// ========================================
// FLOATING LOVE QUOTES - PERSONALIZED
// ========================================

var genericQuotes = [
  "Two hearts, one love...",
  "Forever starts here",
  "Together is our favorite place",
  "Love is the answer",
  "Meant to be",
  "Written in the stars",
  "Soulmates found",
  "Our forever begins now",
  "Love conquers all"
];

var quoteInterval = null;

function getPersonalizedQuotes() {
  var n1 = (window.cjUserNames && window.cjUserNames.name1) || '';
  var n2 = (window.cjUserNames && window.cjUserNames.name2) || '';
  
  if (!n1 && !n2) return genericQuotes;
  
  var personalQuotes = [];
  
  // SVG Icons
  var heart = '<svg class="cj-quote-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var ring = '<svg class="cj-quote-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L2 7l10 15 10-15L12 2zm0 2.5L18.5 7 12 17 5.5 7 12 4.5z"/></svg>';
  var infinity = '<svg class="cj-quote-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4z"/></svg>';
  var star = '<svg class="cj-quote-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  
  if (n1 && n2) {
    // Randomly flip name positions for variety
    var a = Math.random() > 0.5 ? n1 : n2;
    var b = a === n1 ? n2 : n1;
    
    personalQuotes = [
      a + " " + heart + " " + b,
      b + " " + heart + " " + a,
      a + " & " + b,
      b + " & " + a,
      a + " " + infinity + " " + b,
      b + " " + infinity + " " + a,
      "Always " + a + " & " + b,
      "Always " + b + " & " + a,
      a + " & " + b + "'s love story",
      b + " & " + a + "'s love story",
      "Forever " + a + " " + heart + " " + b,
      "Forever " + b + " " + heart + " " + a,
      a + " loves " + b,
      b + " loves " + a,
      "To " + a + ", love " + b,
      "To " + b + ", love " + a,
      a + " " + ring + " " + b + " forever",
      b + " " + ring + " " + a + " forever",
      a + " + " + b,
      b + " + " + a,
      "Together — " + a + " " + heart + " " + b,
      "Together — " + b + " " + heart + " " + a,
      a + " found " + b,
      b + " found " + a,
      "Always & forever — " + a + " & " + b,
      a + " " + heart + " " + b + " — soulmates",
      b + " " + heart + " " + a + " — soulmates",
      star + " " + a + " & " + b + " " + star,
      star + " " + b + " & " + a + " " + star,
      a + " completes " + b,
      b + " completes " + a,
      a + " chose " + b + " " + heart,
      b + " chose " + a + " " + heart,
      "Destined — " + a + " " + heart + " " + b,
      "Destined — " + b + " " + heart + " " + a,
      a + " & " + b + " — always",
      b + " & " + a + " — always",
      a + " is " + b + "'s person",
      b + " is " + a + "'s person",
      "I do — " + a + " " + ring + " " + b,
      "I do — " + b + " " + ring + " " + a,
      a + " & " + b + " say I do",
      "Two rings — one love — " + a + " & " + b,
      "Two rings — one love — " + b + " & " + a,
      a + "'s heart belongs to " + b + " " + heart,
      b + "'s heart belongs to " + a + " " + heart,
      "Endlessly — " + a + " " + infinity + " " + b,
      "Endlessly — " + b + " " + infinity + " " + a,
      a + " adores " + b,
      b + " adores " + a,
      "Til forever — " + a + " " + heart + " " + b,
      "Til forever — " + b + " " + heart + " " + a,
      a + " — " + b + " — Always " + heart,
      b + " — " + a + " — Always " + heart,
      "One love — " + a + " & " + b,
      "One love — " + b + " & " + a,
      a + " " + heart + " " + b + " — Eternal",
      b + " " + heart + " " + a + " — Eternal",
      "Bound together — " + a + " & " + b,
      a + " " + infinity + " " + b + " — Infinite",
      b + " " + infinity + " " + a + " — Infinite",
      "Our story — " + a + " " + heart + " " + b,
      "Our story — " + b + " " + heart + " " + a,
      a + " & " + b + " — Timeless " + star,
      b + " & " + a + " — Timeless " + star
    ];
  } else if (n1) {
    personalQuotes = [
      n1 + "'s forever",
      "For " + n1 + " with love",
      n1 + "'s love story",
      "Always " + n1,
      n1 + " forever"
    ];
  } else if (n2) {
    personalQuotes = [
      n2 + "'s forever",
      "For " + n2 + " with love",
      n2 + "'s love story",
      "Always " + n2,
      n2 + " forever"
    ];
  }
  
  return genericQuotes.concat(personalQuotes);
}

function startFloatingQuotes() {
  var container = document.getElementById('cjQuotes');
  if (!container) return;
  
  quoteInterval = setInterval(function() {
    createFloatingQuote(container);
  }, 6000);
  
  // Create first quote immediately
  setTimeout(function() {
    createFloatingQuote(container);
  }, 2000);
}

function createFloatingQuote(container) {
  var quotes = getPersonalizedQuotes();
  var quote = document.createElement('div');
  quote.className = 'cj-floating-quote';
  quote.innerHTML = quotes[Math.floor(Math.random() * quotes.length)];
  quote.style.top = (20 + Math.random() * 60) + '%';
  quote.style.animationDuration = (15 + Math.random() * 10) + 's';
  
  container.appendChild(quote);
  
  setTimeout(function() {
    if (quote.parentNode) quote.parentNode.removeChild(quote);
  }, 25000);
}

// ========================================
// CINEMATIC TRANSITIONS
// ========================================

window.playCinematicTransition = function(text, callback) {
  var cinematic = document.getElementById('cjCinematic');
  var textEl = document.getElementById('cinematicText');
  
  if (!cinematic || !textEl) {
    if (callback) callback();
    return;
  }
  
  textEl.textContent = text;
  cinematic.classList.add('active');
  
  setTimeout(function() {
    cinematic.classList.remove('active');
    if (callback) callback();
  }, 1500);
};

// ========================================
// SPOTLIGHT REVEAL
// ========================================

window.showSpotlight = function(imageUrl, title, subtitle, callback) {
  var spotlight = document.getElementById('cjSpotlight');
  var img = document.getElementById('spotlightImage');
  var titleEl = document.getElementById('spotlightTitle');
  var subtitleEl = document.getElementById('spotlightSubtitle');
  
  if (!spotlight) {
    if (callback) callback();
    return;
  }
  
  if (img) img.src = imageUrl;
  if (titleEl) titleEl.textContent = title;
  if (subtitleEl) subtitleEl.textContent = subtitle;
  
  spotlight.classList.add('active');
  window.spotlightCallback = callback;
};

window.closeSpotlight = function() {
  var spotlight = document.getElementById('cjSpotlight');
  if (spotlight) {
    spotlight.classList.remove('active');
  }
  if (window.spotlightCallback) {
    window.spotlightCallback();
    window.spotlightCallback = null;
  }
};

// ========================================
// SOUND TOGGLE
// ========================================

var soundEnabled = false;

window.toggleSound = function() {
  soundEnabled = !soundEnabled;
  
  var toggle = document.getElementById('cjSoundToggle');
  var onIcon = document.getElementById('soundOnIcon');
  var offIcon = document.getElementById('soundOffIcon');
  
  if (toggle) {
    toggle.classList.toggle('muted', !soundEnabled);
  }
  if (onIcon) onIcon.style.display = soundEnabled ? 'block' : 'none';
  if (offIcon) offIcon.style.display = soundEnabled ? 'none' : 'block';
};

// ========================================
// SHARE SYSTEM
// ========================================

window.openShareModal = function() {
  var modal = document.getElementById('cjShareModal');
  var ring1Img = document.getElementById('shareRing1Img');
  var ring2Img = document.getElementById('shareRing2Img');
  
  if (ring1Img && cjState.ring1.styleImage) {
    ring1Img.src = cjState.ring1.styleImage;
  }
  if (ring2Img && cjState.ring2.styleImage) {
    ring2Img.src = cjState.ring2.styleImage;
  }
  
  if (modal) modal.classList.add('active');
};

window.closeShareModal = function() {
  var modal = document.getElementById('cjShareModal');
  if (modal) modal.classList.remove('active');
};

window.shareToFacebook = function() {
  var url = encodeURIComponent(window.location.href);
  window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank', 'width=600,height=400');
};

window.shareToTwitter = function() {
  var url = encodeURIComponent(window.location.href);
  var text = encodeURIComponent('We found our perfect matching rings! 💍');
  window.open('https://twitter.com/intent/tweet?url=' + url + '&text=' + text, '_blank', 'width=600,height=400');
};

window.shareToPinterest = function() {
  var url = encodeURIComponent(window.location.href);
  var img = cjState.ring1.styleImage ? encodeURIComponent(cjState.ring1.styleImage) : '';
  window.open('https://pinterest.com/pin/create/button/?url=' + url + '&media=' + img, '_blank', 'width=600,height=400');
};

window.copyShareLink = function() {
  navigator.clipboard.writeText(window.location.href).then(function() {
    showMilestone('Link copied to clipboard!');
  });
};

// ========================================
// EPIC EXPERIENCE SYSTEM
// ========================================

// Intro Splash Animation
(function initIntroSplash() {
  var splash = document.getElementById('cjIntroSplash');
  var builder = document.getElementById('couplesJourney');
  var heart = document.getElementById('introHeart');
  var rings = document.querySelectorAll('.cj-intro-splash__ring');
  
  if (!splash) return;
  
  // After rings float in, show heart and merge rings
  setTimeout(function() {
    if (heart) heart.classList.add('show');
    rings.forEach(function(ring) {
      ring.classList.add('merge');
    });
  }, 1800);
})();

// Dismiss intro splash
window.dismissIntroSplash = function() {
  var splash = document.getElementById('cjIntroSplash');
  var builder = document.getElementById('couplesJourney');
  
  if (splash) {
    splash.classList.add('fade-out');
    
    // Show builder after fade
    setTimeout(function() {
      splash.style.display = 'none';
      if (builder) {
        builder.style.display = 'block';
        // Trigger entrance animation
        builder.classList.add('cj-step-celebrate');
      }
      // Celebration burst!
      triggerCelebration('burst');
      showMilestone('Welcome to your journey!');
    }, 800);
  }
};

// Skip intro (for returning visitors)
window.skipIntro = function() {
  var splash = document.getElementById('cjIntroSplash');
  var builder = document.getElementById('couplesJourney');
  
  if (splash) splash.style.display = 'none';
  if (builder) builder.style.display = 'block';
};

// Celebration System - DISABLED (confetti removed)
window.triggerCelebration = function(type, intensity) {
  // Confetti and celebrations disabled
  return;
};

// Milestone Popup System
window.showMilestone = function(message) {
  var popup = document.getElementById('cjMilestone');
  var textEl = document.getElementById('cjMilestoneText');
  
  if (!popup || !textEl) return;
  
  textEl.textContent = message;
  popup.classList.remove('show');
  
  // Trigger reflow
  void popup.offsetWidth;
  
  popup.classList.add('show');
  
  // Remove after animation
  setTimeout(function() {
    popup.classList.remove('show');
  }, 3500);
};

// Celebration messages for different actions
var celebrationMessages = {
  categorySelected: [
    "Great choice!",
    "Perfect theme!",
    "Love this selection!",
    "Excellent taste!"
  ],
  ringSelected: [
    "Beautiful ring!",
    "Stunning choice!",
    "Perfect pick!",
    "Love it!"
  ],
  styleSelected: [
    "That style is gorgeous!",
    "Perfect style choice!",
    "Beautiful design!"
  ],
  sizeSelected: [
    "Size locked in!",
    "Perfect fit coming up!",
    "Great, almost there!"
  ],
  engravingComplete: [
    "Those words are beautiful!",
    "So meaningful!",
    "That's perfect!"
  ],
  ring1Complete: [
    "First ring done! Let's find the match!",
    "Perfect! Now let's complete the set!",
    "Beautiful choice! One more to go!"
  ],
  ring2Complete: [
    "Both rings selected! Time for the magic!",
    "The set is complete! Let's see them together!",
    "Perfect pair! Ready for checkout!"
  ]
};

// 🔥 Get personalized message with names
function getPersonalizedMessage(type) {
  var name1 = (window.cjUserNames && window.cjUserNames.name1) || 'Partner 1';
  var name2 = (window.cjUserNames && window.cjUserNames.name2) || 'Partner 2';
  
  var personalMessages = {
    ring1Complete: [
      name1 + "'s ring is perfect! Now for " + name2 + "!",
      "Beautiful choice for " + name1 + "! Let's find " + name2 + "'s ring!",
      name1 + "'s ring is ready! On to " + name2 + "!"
    ],
    ring2Complete: [
      "Both rings are perfect! " + name1 + " & " + name2 + " forever!",
      name1 + " & " + name2 + "'s set is complete!",
      "The perfect pair for " + name1 + " & " + name2 + "!"
    ]
  };
  
  if (personalMessages[type]) {
    var msgs = personalMessages[type];
    return msgs[Math.floor(Math.random() * msgs.length)];
  }
  return getRandomMessage(type);
}

function getRandomMessage(type) {
  var messages = celebrationMessages[type];
  if (!messages || !messages.length) return "Great!";
  return messages[Math.floor(Math.random() * messages.length)];
}

// Track milestones
var milestonesTriggered = {
  category: false,
  ring1Selected: false,
  ring1Style: false,
  ring1Size: false,
  ring1Engraving: false,
  ring1Complete: false,
  ring2Selected: false,
  ring2Style: false,
  ring2Size: false,
  ring2Engraving: false,
  ring2Complete: false
};

// Hook into actions for celebrations
window.celebrateAction = function(action) {
  if (milestonesTriggered[action]) return;
  milestonesTriggered[action] = true;
  
  switch(action) {
    case 'category':
      triggerCelebration('confetti', 'low');
      showMilestone(getRandomMessage('categorySelected'));
      break;
    case 'ring1Selected':
    case 'ring2Selected':
      triggerCelebration('confetti', 'medium');
      showMilestone(getRandomMessage('ringSelected'));
      break;
    case 'ring1Style':
    case 'ring2Style':
      triggerCelebration('burst');
      showMilestone(getRandomMessage('styleSelected'));
      break;
    case 'ring1Size':
    case 'ring2Size':
      showMilestone(getRandomMessage('sizeSelected'));
      break;
    case 'ring1Engraving':
    case 'ring2Engraving':
      triggerCelebration('confetti', 'low');
      showMilestone(getRandomMessage('engravingComplete'));
      break;
    case 'ring1Complete':
      triggerCelebration('confetti', 'high');
      showMilestone(getPersonalizedMessage('ring1Complete'));
      break;
    case 'ring2Complete':
      triggerCelebration('confetti', 'high');
      showMilestone(getPersonalizedMessage('ring2Complete'));
      break;
  }
};

// Reset milestones for each ring selection (in case they change their mind)
window.resetRingMilestones = function(ringNum) {
  if (ringNum === 1) {
    milestonesTriggered.ring1Selected = false;
    milestonesTriggered.ring1Style = false;
    milestonesTriggered.ring1Size = false;
    milestonesTriggered.ring1Engraving = false;
    milestonesTriggered.ring1Complete = false;
  } else {
    milestonesTriggered.ring2Selected = false;
    milestonesTriggered.ring2Style = false;
    milestonesTriggered.ring2Size = false;
    milestonesTriggered.ring2Engraving = false;
    milestonesTriggered.ring2Complete = false;
  }
};

// ========================================
// END EPIC EXPERIENCE SYSTEM
// ========================================

// Use window.cjState so inline scripts can access it
window.cjState = window.cjState || {};
var cjState = window.cjState;
cjState.currentStep = cjState.currentStep || 1;
cjState.searchMode = cjState.searchMode || null;
cjState.searchQuery = cjState.searchQuery || '';
cjState.categoryHandle = cjState.categoryHandle || '';
cjState.categoryName = cjState.categoryName || '';
cjState.products = cjState.products || [];
cjState.productsShown = cjState.productsShown || 12;
cjState.ring1 = cjState.ring1 || { 
    product: null,
    ringConfig: null,
    defaultVariantId: null,
    // Style selection (matches product page widgetState)
    selectedStyleIndex: -1,
    selectedStyleCode: '',
    selectedStyleLabel: '',
    style: '',
    styleImage: '',
    availableStyles: [],
    // Size & engraving
    size: '', 
    engraving: '', 
    font: 'Monotype Corsiva' 
  };
cjState.ring2 = cjState.ring2 || { 
    product: null,
    ringConfig: null,
    defaultVariantId: null,
    // Style selection (matches product page widgetState)
    selectedStyleIndex: -1,
    selectedStyleCode: '',
    selectedStyleLabel: '',
    style: '',
    styleImage: '',
    availableStyles: [],
    // Size & engraving
    size: '', 
    engraving: '', 
    font: 'Monotype Corsiva' 
};

// Initialize when DOM ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('Couples Builder initialized');
  
  // Search input
  var searchInput = document.getElementById('searchInput');
  if (searchInput) {
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.performSearch();
      }
    });
    searchInput.addEventListener('input', function() {
      if (this.value.trim().length > 0) {
        cjState.searchQuery = this.value.trim();
        var btn = document.getElementById('step1Next');
        if (btn) btn.disabled = false;
      }
    });
  }
  
  // Setup size button clicks
  setupSizeButtons('his');
  setupSizeButtons('her');
  
  // Setup engraving inputs
  setupEngravingInput('his');
  setupEngravingInput('her');
  
  // Setup font dropdowns
  setupFontDropdown('his');
  setupFontDropdown('her');
  
  // Close dropdowns on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.cj-custom-select')) {
      document.querySelectorAll('.cj-custom-select').forEach(function(el) {
        el.classList.remove('open');
      });
    }
  });
});

// Setup size buttons for a ring type
function setupSizeButtons(ringType) {
  var container = document.getElementById(ringType + 'SizeButtons');
  if (!container) return;
  
  container.querySelectorAll('.cj-size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Remove active from all
      container.querySelectorAll('.cj-size-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      // Add active to clicked
      this.classList.add('active');
      
      var size = this.getAttribute('data-size');
      var hiddenInput = document.getElementById(ringType + 'Size');
      if (hiddenInput) hiddenInput.value = size;
      
      var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
      cjState[ringKey].size = size;
      
      // Hide error
      var error = document.getElementById(ringType + 'SizeError');
      if (error) error.style.display = 'none';
      
      // Update button
      if (ringType === 'his') {
        window.updateStep2Button();
        celebrateAction('ring1Size');
      }
      if (ringType === 'her') {
        window.updateStep3Button();
        celebrateAction('ring2Size');
      }
      
      // Visual celebration
      this.classList.add('cj-ring-selected-celebrate');
    });
  });
}

// Setup engraving input for a ring type
function setupEngravingInput(ringType) {
  var input = document.getElementById(ringType + 'Engraving');
  if (!input) return;
  
  input.addEventListener('input', function() {
    var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
    cjState[ringKey].engraving = this.value;
    updateEngravingPreview(ringType, this.value);
    
    // Hide error if has text
    if (this.value.trim()) {
      var error = document.getElementById(ringType + 'EngravingError');
      if (error) error.style.display = 'none';
    }
    
    // Update button
    if (ringType === 'his') window.updateStep2Button();
    if (ringType === 'her') window.updateStep3Button();
  });
  
  // Celebrate when engraving is complete (on blur with text)
  input.addEventListener('blur', function() {
    if (this.value.trim().length >= 3) {
      if (ringType === 'his') {
        celebrateAction('ring1Engraving');
      } else {
        celebrateAction('ring2Engraving');
      }
    }
  });
}

// Setup font dropdown for a ring type
function setupFontDropdown(ringType) {
  var dropdown = document.getElementById(ringType + 'Font-dropdown');
  var trigger = document.getElementById(ringType + 'Font-trigger');
  var options = document.getElementById(ringType + 'Font-options');
  var hiddenInput = document.getElementById(ringType + 'Font');
  var selectedSpan = document.getElementById(ringType + 'Font-selected');
  
  if (!dropdown || !trigger || !options) return;
  
  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    dropdown.classList.toggle('open');
  });
  
  options.querySelectorAll('.cj-select-option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var value = this.getAttribute('data-value');
      var fontFamily = window.getComputedStyle(this).fontFamily;
      
      // Update selected display
      if (selectedSpan) {
        selectedSpan.textContent = value;
        selectedSpan.style.fontFamily = fontFamily;
      }
      
      // Update hidden input
      if (hiddenInput) hiddenInput.value = value;
      
      // Update state
      var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
      cjState[ringKey].font = value;
      
      // Update active class
      options.querySelectorAll('.cj-select-option').forEach(function(o) {
        o.classList.remove('active');
      });
      this.classList.add('active');
      
      // Close dropdown
      dropdown.classList.remove('open');
      
      // Update preview
      var engravingInput = document.getElementById(ringType + 'Engraving');
      if (engravingInput) {
        updateEngravingPreview(ringType, engravingInput.value);
      }
    });
  });
}

// Select search or browse option
window.selectOption = function(option) {
  console.log('Option selected:', option);
  
  // Update UI
  document.querySelectorAll('.cj-option').forEach(function(el) {
    el.classList.remove('selected');
  });
  var selected = document.querySelector('[data-option="' + option + '"]');
  if (selected) selected.classList.add('selected');
  
  cjState.searchMode = option;
  
  var searchBox = document.getElementById('searchBox');
  var categoryBox = document.getElementById('categoryBox');
  
  if (searchBox) {
    if (option === 'search') {
      searchBox.classList.add('visible');
      // Focus search input
      var input = document.getElementById('searchInput');
      if (input) setTimeout(function() { input.focus(); }, 100);
    } else {
      searchBox.classList.remove('visible');
    }
  }
  
  if (categoryBox) {
    if (option === 'browse') {
      categoryBox.classList.add('visible');
    } else {
      categoryBox.classList.remove('visible');
    }
  }
  
  // Reset continue button
  var btn = document.getElementById('step1Next');
  if (btn) btn.disabled = true;
};

// Quick search from suggestion tags
window.quickSearch = function(term) {
  console.log('Quick search:', term);
  var input = document.getElementById('searchInput');
  if (input) {
    input.value = term;
    window.performSearch();
  }
};

// Perform search
window.performSearch = function() {
  var input = document.getElementById('searchInput');
  var query = input ? input.value.trim() : '';
  
  console.log('Performing search:', query);
  
  if (!query) {
    alert('Please enter a search term');
    return;
  }
  
  cjState.searchQuery = query;
  cjState.categoryHandle = '';
  
  // 🔥 GO DIRECTLY TO RING 1 SELECTION!
  if (typeof goToStep === 'function') {
    goToStep(2);
  } else if (typeof window.goToStep === 'function') {
    window.goToStep(2);
  }
};

// REMOVED OLD CODE - Search now goes directly to next step
window._oldSearchConfirm = function() {
  var searchBox = document.getElementById('searchBox');
  if (searchBox) {
    var existing = searchBox.querySelector('.cj-search-confirm');
    if (existing) existing.remove();
    
    var confirm = document.createElement('div');
    confirm.className = 'cj-search-confirm';
    confirm.innerHTML = 'âœ“ Ready to search for "<strong>' + query + '</strong>" - Click Continue below!';
    confirm.style.cssText = 'margin-top: 20px; padding: 15px 20px; background: rgba(90, 123, 123, 0.1); border: 1px solid rgba(90, 123, 123, 0.3); border-radius: 8px; color: #5A7B7B; font-weight: 600; text-align: center;';
    searchBox.appendChild(confirm);
  }
};

// Select category
window.selectCategory = function(handle, icon, name) {
  console.log('Category selected:', handle, name);
  
  document.querySelectorAll('.cj-category').forEach(function(el) {
    el.classList.remove('selected');
  });
  
  if (event && event.currentTarget) {
    event.currentTarget.classList.add('selected');
    event.currentTarget.classList.add('cj-ring-selected-celebrate');
  }
  
  cjState.categoryHandle = handle;
  cjState.categoryName = name;
  cjState.searchQuery = '';
  
  var btn = document.getElementById('step1Next');
  if (btn) btn.disabled = false;
  
  // CELEBRATION!
  celebrateAction('category');
};

// Open Virtual Try-On - Works directly in couples builder!
window.openTryOn = function(ringType) {
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  var ringState = cjState[ringKey];
  
  if (!ringState || !ringState.product) {
    alert('Please select a ring first to try it on!');
    return;
  }
  
  // Get the selected style image or product image
  var imageUrl = ringState.styleImage || (ringState.product.images && ringState.product.images[0] ? ringState.product.images[0].src : '');
  
  if (!imageUrl) {
    alert('Please select a ring style first!');
    return;
  }
  
  // Open the built-in try-on modal
  var overlay = document.getElementById('cjTryonOverlay');
  var productName = document.getElementById('cjTryonProductName');
  var productThumb = document.getElementById('cjTryonProductThumb');
  
  if (overlay) {
    // Set product info
    if (productName) productName.textContent = ringState.product.title || 'Selected Ring';
    if (productThumb) productThumb.src = imageUrl;
    
    // Store current ring image for AR
    window.cjCurrentTryOnImage = imageUrl;
    window.cjCurrentTryOnRing = ringType;
    
    // Open modal
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Start camera
    startCJTryOnCamera();
  }
};
  
// Navigation between steps - USES PREMIUM TRANSITION FROM LIQUID FILE
// The main goToStep function is defined in tp-couples-ring-builder.liquid
// with the billion dollar ring loader transition

window.completeStepTransitionExtras = function(step) {
  // Update Love Meter based on step
  try {
    var loveProgress = { 1: 10, 2: 30, 3: 60, 4: 100 };
    if (typeof addLoveProgress === 'function') {
      addLoveProgress(loveProgress[step] - currentLoveProgress);
    }
  } catch(e) { console.log('Love meter error:', e); }
  
  // Extra celebrations with personalized names
  var name1 = (window.cjUserNames && window.cjUserNames.name1) || 'Partner 1';
  var name2 = (window.cjUserNames && window.cjUserNames.name2) || 'Partner 2';
  
  if (step === 2) {
    showMilestone("Let's find " + name1 + "'s perfect ring!");
    unlockAchievement('theme-chosen');
  }
  if (step === 3) {
    celebrateAction('ring1Complete');
    unlockAchievement('ring1-complete');
  }
  
  // STEP 4: Trigger Infinity Animation!
  if (step === 4) {
    // Celebrate completing Ring 2!
    celebrateAction('ring2Complete');
    unlockAchievement('ring2-complete');
    startInfinityAnimation();
    updateCheckout();
  }
  
  // Add celebration to step indicator
  var activeStep = document.querySelector('.cj-progress__step.active');
  if (activeStep) {
    activeStep.classList.add('cj-step-celebrate');
  }
  
  // Scroll to top
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// ========================================
// INFINITY RING ANIMATION - BILLION DOLLAR
// ========================================
var infinityAnimationTimeout = null;
var infinityAnimationPlayed = false;

window.startInfinityAnimation = function() {
  var animation = document.getElementById('infinityAnimation');
  var summary = document.getElementById('checkoutSummary');
  
  if (!animation || !summary) return;
  
  // If animation already played, skip it and show summary directly
  if (infinityAnimationPlayed) {
    animation.style.display = 'none';
    summary.style.display = 'grid';
    return;
  }
  
  // Mark as played
  infinityAnimationPlayed = true;
  
  // Set ring images from selected products
  var ring1Img = document.getElementById('infinityRing1Img');
  var ring2Img = document.getElementById('infinityRing2Img');
  
  if (ring1Img && cjState.ring1.styleImage) {
    ring1Img.src = cjState.ring1.styleImage;
  } else if (ring1Img && cjState.ring1.product && cjState.ring1.product.images && cjState.ring1.product.images[0]) {
    ring1Img.src = cjState.ring1.product.images[0].src;
  }
  
  if (ring2Img && cjState.ring2.styleImage) {
    ring2Img.src = cjState.ring2.styleImage;
  } else if (ring2Img && cjState.ring2.product && cjState.ring2.product.images && cjState.ring2.product.images[0]) {
    ring2Img.src = cjState.ring2.product.images[0].src;
  }
  
  // Set engraving text and fonts
  setEngravingAnimationText();
  
  // Reset and show animation
  animation.style.display = 'flex';
  animation.classList.remove('hidden');
  animation.classList.add('playing');
  summary.style.display = 'none';
  
  // Clear any existing timeout
  if (infinityAnimationTimeout) {
    clearTimeout(infinityAnimationTimeout);
  }
  
  // Auto-finish after animation completes (7 seconds - extended for engravings)
  infinityAnimationTimeout = setTimeout(function() {
    finishInfinityAnimation();
  }, 7000);
}

// Set engraving text with proper fonts for animation
function setEngravingAnimationText() {
  var engraving1El = document.getElementById('infinityEngraving1');
  var engraving2El = document.getElementById('infinityEngraving2');
  
  // Font mapping to CSS classes
  var fontClassMap = {
    'Monotype Corsiva': 'cj-engraving-font-monotype',
    'Arial': 'cj-engraving-font-arial',
    'Times New Roman': 'cj-engraving-font-times',
    'Commercial Script BT': 'cj-engraving-font-commercial',
    'Bradley Hand ITC': 'cj-engraving-font-bradley',
    'French Script MT': 'cj-engraving-font-french',
    'Comic Sans': 'cj-engraving-font-comic',
    'Mistral': 'cj-engraving-font-mistral'
  };
  
  // Ring 1 Engraving with typewriter effect
  if (engraving1El) {
    var text1 = cjState.ring1.engraving || 'Your Message';
    var font1 = cjState.ring1.font || 'Monotype Corsiva';
    var fontClass1 = fontClassMap[font1] || 'cj-engraving-font-monotype';
    
    engraving1El.className = 'cj-infinity__engraving-text';
    engraving1El.classList.add(fontClass1);
    engraving1El.innerHTML = '<span class="cj-typewriter-cursor"></span>';
    
    // Start typewriter after slide-in animation
    setTimeout(function() {
      typewriterEffect(engraving1El, '"' + text1 + '"', 50);
    }, 3300);
  }
  
  // Ring 2 Engraving with typewriter effect
  if (engraving2El) {
    var text2 = cjState.ring2.engraving || 'Your Message';
    var font2 = cjState.ring2.font || 'Monotype Corsiva';
    var fontClass2 = fontClassMap[font2] || 'cj-engraving-font-monotype';
    
    engraving2El.className = 'cj-infinity__engraving-text';
    engraving2El.classList.add(fontClass2);
    engraving2El.innerHTML = '<span class="cj-typewriter-cursor"></span>';
    
    // Start typewriter after slide-in animation (slightly delayed)
    setTimeout(function() {
      typewriterEffect(engraving2El, '"' + text2 + '"', 50);
    }, 3600);
  }
}

// Typewriter effect function - looks like laser engraving
function typewriterEffect(element, text, speed) {
  var i = 0;
  element.innerHTML = '<span class="cj-typewriter-text"></span><span class="cj-typewriter-cursor"></span>';
  var textSpan = element.querySelector('.cj-typewriter-text');
  var cursor = element.querySelector('.cj-typewriter-cursor');
  
  function type() {
    if (i < text.length) {
      // Add laser spark effect
      cursor.classList.add('sparking');
      
      textSpan.textContent += text.charAt(i);
      i++;
      
      // Remove spark after brief moment
      setTimeout(function() {
        cursor.classList.remove('sparking');
      }, 30);
      
      setTimeout(type, speed + Math.random() * 30);
    } else {
      // Done typing - hide cursor
      cursor.style.display = 'none';
      element.classList.add('typing-complete');
    }
  }
  
  type();
}

function skipInfinityAnimation() {
  if (infinityAnimationTimeout) {
    clearTimeout(infinityAnimationTimeout);
  }
  finishInfinityAnimation();
}

function finishInfinityAnimation() {
  var animation = document.getElementById('infinityAnimation');
  var summary = document.getElementById('checkoutSummary');
  
  if (!animation || !summary) return;
  
  // Fade out animation
  animation.classList.add('hidden');
  
  // After fade, hide animation and show summary
  setTimeout(function() {
    animation.style.display = 'none';
    animation.classList.remove('playing', 'hidden');
    summary.style.display = 'grid';
    
    // Add entrance animation to summary cards
    var cards = summary.querySelectorAll('.cj-summary-card');
    cards.forEach(function(card, index) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      setTimeout(function() {
        card.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }, index * 200);
    });
  }, 600);
}

// Make skip function global
window.skipInfinityAnimation = skipInfinityAnimation;

// Load Products from Shopify
window.loadProducts = function(ringType) {
  console.log('Loading products for:', ringType, 'Query:', cjState.searchQuery, 'Category:', cjState.categoryHandle);

  var container = document.getElementById(ringType + 'ProductsContainer');
  var queryText = document.getElementById(ringType + 'QueryText');

  if (!container) {
    console.error('Container not found:', ringType + 'ProductsContainer');
    return;
  }

  // 🔥 LOAD REAL COLLECTION FILTERS
  var collectionHandle = cjState.categoryHandle || 'all';
  if (typeof window.cjLoadCollectionFilters === 'function') {
    window.cjLoadCollectionFilters(ringType, collectionHandle);
    console.log('🔥 Loading collection filters for:', collectionHandle);
  }

  // Show loading
  container.innerHTML = '<div class="cj-loading"><div class="cj-loading__spinner"></div><p class="cj-loading__text">Finding perfect rings...</p></div>';

  // Set query text
  if (queryText) {
    if (cjState.searchQuery) {
      queryText.innerHTML = 'Showing results for: <strong>"' + escapeHtml(cjState.searchQuery) + '"</strong>';
    } else if (cjState.categoryHandle) {
      queryText.innerHTML = 'Browsing: <strong>' + escapeHtml(cjState.categoryName) + '</strong>';
    }
  }

  // Build URL - use collection if category selected, otherwise all products
  var url = cjState.categoryHandle && cjState.categoryHandle !== 'all'
    ? '/collections/' + cjState.categoryHandle + '/products.json?limit=100'
    : '/collections/all/products.json?limit=100';
  
  console.log('Fetching from:', url);
  
  // Fetch products
  fetch(url)
    .then(function(r) { 
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json(); 
    })
    .then(function(data) {
      console.log('Got products:', data.products ? data.products.length : 0);
      var products = data.products || [];
      
      // Filter by search query if provided
      if (cjState.searchQuery) {
        var query = cjState.searchQuery.toLowerCase();
        products = products.filter(function(p) {
          var title = (p.title || '').toLowerCase();
          var tags = (p.tags || []).join(' ').toLowerCase();
          var type = (p.product_type || '').toLowerCase();
          var vendor = (p.vendor || '').toLowerCase();
          
          return title.indexOf(query) !== -1 || 
                 tags.indexOf(query) !== -1 ||
                 type.indexOf(query) !== -1 ||
                 vendor.indexOf(query) !== -1;
        });
        console.log('Filtered to:', products.length, 'products matching:', query);
      }
      
      cjState.products = products;
      cjState.productsShown = 12;
      renderProducts(ringType);
    })
    .catch(function(err) {
      console.error('Failed to load products:', err);
      container.innerHTML = '<div class="cj-no-results"><div class="cj-no-results__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 15s1.5-2 4-2 4 2 4 2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg></div><p class="cj-no-results__text">Couldn\'t load products</p><p class="cj-no-results__hint">Please try again</p></div>';
    });
}
  
  // Render product grid
window.renderProducts = function(ringType) {
  var container = document.getElementById(ringType + 'ProductsContainer');
  var products = cjState.products.slice(0, cjState.productsShown);

  console.log('Rendering', products.length, 'products');

  if (products.length === 0) {
    container.innerHTML = '<div class="cj-no-results"><div class="cj-no-results__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg></div><p class="cj-no-results__text">No rings found</p><p class="cj-no-results__hint">Try a different search or category</p></div>';
    return;
  }

  // Get wishlist - matches collection page
  var wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem('shopify_favorites') || '[]'); } catch(e) {}
  var wishlistIds = wishlist.map(function(w) { return String(typeof w === 'string' ? w : (w.productId || w.id)); });

  var html = '<div class="cj-products">';
  products.forEach(function(p, index) {
    var img = p.images && p.images[0] ? p.images[0].src : '';
    var price = p.variants && p.variants[0] ? p.variants[0].price : '0';
    var comparePrice = p.variants && p.variants[0] && p.variants[0].compare_at_price ? p.variants[0].compare_at_price : null;
    var productId = p.id || index;
    var safeTitle = (p.title || '').replace(/'/g, "\\'").replace(/"/g, '&quot;');
    var isWished = wishlistIds.indexOf(String(productId)) > -1;

    html += '<div class="cj-product" data-product-id="' + productId + '" style="position:relative;">';
    
    // Heart wishlist icon - matches collection page
    html += '<div class="cj-product__wishlist' + (isWished ? ' active' : '') + '" onclick="event.stopPropagation();cjToggleWishlist(this,\'' + productId + '\',\'' + (p.handle || '') + '\',\'' + safeTitle + '\',\'' + img + '\',\'' + price + '\')">';
    html += '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    html += '</div>';
    
    html += '<div class="cj-product__click" onclick="selectProductById(\'' + ringType + '\', ' + index + ')" style="cursor:pointer;">';
    html += '<img class="cj-product__img" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
    html += '<div class="cj-product__name">' + escapeHtml(p.title) + '</div>';
    html += '<div class="cj-product__price" style="display:flex;align-items:center;justify-content:center;gap:8px;">';
    if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
      html += '<span style="text-decoration:line-through;color:rgba(255,255,255,0.4);font-size:0.8rem;">$' + parseFloat(comparePrice).toFixed(2) + '</span>';
    }
    html += '<span style="color:#E8B4B8;">$' + parseFloat(price).toFixed(2) + '</span>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
  });
  html += '</div>';
  
  if (cjState.productsShown < cjState.products.length) {
    html += '<div class="cj-load-more"><button class="cj-load-more__btn" onclick="loadMore(\'' + ringType + '\')">Show More (' + (cjState.products.length - cjState.productsShown) + ' more)</button></div>';
  }
  
  container.innerHTML = html;
}

// Load more products
window.loadMore = function(ringType) {
  cjState.productsShown += 12;
  renderProducts(ringType);
};

// Select product by index (simpler than passing whole object)
window.selectProductById = function(ringType, index) {
  // Check both cjState.products and window.cjProducts
  var product = null;
  if (cjState.products && cjState.products[index]) {
    product = cjState.products[index];
  } else if (window.cjProducts && window.cjProducts[ringType] && window.cjProducts[ringType][index]) {
    product = window.cjProducts[ringType][index];
    // Sync to cjState
    cjState.products = window.cjProducts[ringType];
  }
  
  if (!product) {
    console.error('Product not found at index:', index);
    return;
  }
  
  console.log('🔥 Selected product:', product.title, product);
  
  // Store in correct ring slot
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  
  // Initialize ring state if needed
  cjState[ringKey] = cjState[ringKey] || {
    product: null,
    ringConfig: null,
    selectedStyleIndex: -1,
    style: '',
    styleImage: '',
    size: '',
    engraving: '',
    font: 'Monotype Corsiva'
  };
  
  cjState[ringKey].product = product;
  
  // Get product image and price
  var productImg = (product.images && product.images[0]) ? (product.images[0].src || product.images[0]) : '';
  var productPrice = (product.variants && product.variants[0]) ? product.variants[0].price : (product.price || 0);

  // Store EVERYTHING - including explicit price and name for checkout
  cjState[ringKey].style = '';
  cjState[ringKey].styleImage = productImg;
  cjState[ringKey].price = productPrice; // Store price explicitly
  cjState[ringKey].productName = product.title; // Store name explicitly
  cjState[ringKey].size = '';
  cjState[ringKey].engraving = '';
  cjState[ringKey].selectedStyleIndex = -1;
  
  // ALSO sync to window.cjState
  window.cjState = window.cjState || {};
  window.cjState[ringKey] = window.cjState[ringKey] || {};
  window.cjState[ringKey].product = product;
  window.cjState[ringKey].styleImage = productImg;
  window.cjState[ringKey].price = productPrice;
  window.cjState[ringKey].productName = product.title;
  
  console.log('🔥 PRODUCT STORED:', {
    ringKey: ringKey,
    title: product.title,
    price: productPrice,
    img: productImg ? productImg.substring(0, 50) + '...' : 'none'
  });
  
  // Update preview UI
  var previewContainer = document.getElementById(ringType + 'PreviewContainer');
  var img = productImg;
  var price = productPrice;
  
  var previewImg = document.getElementById(ringType + 'PreviewImg');
  var previewName = document.getElementById(ringType + 'PreviewName');
  var previewPrice = document.getElementById(ringType + 'PreviewPrice');
  
  if (previewImg) previewImg.src = img;
  if (previewName) previewName.textContent = product.title;
  if (previewPrice) previewPrice.textContent = '$' + parseFloat(price).toFixed(2);
  
  if (previewContainer) previewContainer.style.display = 'block';
  
  // Hide products grid
  var productsContainer = document.getElementById(ringType + 'ProductsContainer');
  if (productsContainer) productsContainer.style.display = 'none';
  
  // Hide filter toolbar when product is selected
  var filterToolbar = document.getElementById(ringType + 'FilterToolbar');
  if (filterToolbar) filterToolbar.style.display = 'none';
  
  // Load ring styles from product
  loadRingStyles(ringType, product);
  
  // Reset UI
  resetSelections(ringType);
  
  // Update nav button
  if (ringType === 'his') {
    window.updateStep2Button();
    celebrateAction('ring1Selected');
    resetRingMilestones(1);
  }
  if (ringType === 'her') {
    window.updateStep3Button();
    celebrateAction('ring2Selected');
    resetRingMilestones(2);
  }
};

// Load ring styles by fetching RAMBO_RING_CONFIG from product page
window.loadRingStyles = function(ringType, product) {
  var container = document.getElementById(ringType + 'StyleSwatches');
  if (!container) return;
  
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  
  // Show loading
  container.innerHTML = '<p class="cj-style-loading">Loading styles...</p>';
  
  // Set a timeout - if fetch takes too long, use product images
  var timeout = setTimeout(function() {
    console.log('Style load timeout - using product images fallback');
    buildFallbackStyles(ringType, product, container, ringKey);
  }, 3000);
  
  // Fetch the product page to get RAMBO_RING_CONFIG
  fetch('/products/' + product.handle)
    .then(function(response) { return response.text(); })
    .then(function(html) {
      clearTimeout(timeout);
      var ringConfig = null;
      
      // Extract RAMBO_RING_CONFIG from the page - try multiple patterns
      var configMatch = html.match(/window\.RAMBO_RING_CONFIG\s*=\s*(\{[\s\S]*?\});/);
      if (!configMatch) {
        // Try without semicolon
        configMatch = html.match(/window\.RAMBO_RING_CONFIG\s*=\s*(\{[\s\S]*?\})\s*[;\n<]/);
      }
      if (!configMatch) {
        // Try getting the full JSON block
        var startIdx = html.indexOf('window.RAMBO_RING_CONFIG');
        if (startIdx !== -1) {
          var jsonStart = html.indexOf('{', startIdx);
          if (jsonStart !== -1) {
            // Find matching closing brace
            var depth = 0;
            var jsonEnd = jsonStart;
            for (var i = jsonStart; i < html.length && i < jsonStart + 50000; i++) {
              if (html[i] === '{') depth++;
              if (html[i] === '}') depth--;
              if (depth === 0) { jsonEnd = i; break; }
            }
            if (jsonEnd > jsonStart) {
              try {
                ringConfig = JSON.parse(html.substring(jsonStart, jsonEnd + 1));
                console.log('Found RAMBO_RING_CONFIG (manual parse):', ringConfig);
              } catch (e) {
                console.log('Manual parse failed');
              }
            }
          }
        }
      }
      
      if (configMatch && !ringConfig) {
        try {
          ringConfig = JSON.parse(configMatch[1]);
          console.log('Found RAMBO_RING_CONFIG:', ringConfig);
        } catch (e) {
          console.log('Failed to parse RAMBO_RING_CONFIG');
        }
      }
      
      // Also try to get default variant ID
      var variantMatch = html.match(/"defaultVariantId":\s*(\d+)/);
      var defaultVariantId = variantMatch ? variantMatch[1] : (product.variants[0] ? product.variants[0].id : null);
      
      cjState[ringKey].defaultVariantId = defaultVariantId;
      cjState[ringKey].ringConfig = ringConfig;
      
      if (ringConfig && ringConfig.styles && ringConfig.styles.length > 0) {
        // Use the actual RAMBO_RING_CONFIG styles
        renderRamboStyles(ringType, ringConfig);
      } else {
        // Fallback: use product images
        buildFallbackStyles(ringType, product, container, ringKey);
      }
    })
    .catch(function(err) {
      clearTimeout(timeout);
      console.error('Failed to load ring config:', err);
      buildFallbackStyles(ringType, product, container, ringKey);
    });
};

// Build fallback styles from product images
function buildFallbackStyles(ringType, product, container, ringKey) {
  console.log('Building fallback styles from product images');
        var styles = [];
        if (product.images && product.images.length > 0) {
          product.images.slice(0, 15).forEach(function(img, idx) {
            styles.push({
              label: 'Style ' + String(idx + 1).padStart(2, '0'),
              code: String(idx + 1).padStart(2, '0'),
              swatchImage: img.src || img,
              variants: [{ sizeCode: '', shopifyVariantId: product.variants[0] ? product.variants[0].id : null }]
            });
          });
        }
  
  if (styles.length === 0) {
    container.innerHTML = '<p class="cj-style-placeholder">No styles available for this product</p>';
    return;
  }
  
        cjState[ringKey].ringConfig = { styles: styles };
        renderRamboStyles(ringType, { styles: styles });
}

// Render styles using RAMBO format (matches product page exactly)
window.renderRamboStyles = function(ringType, ringConfig) {
  var container = document.getElementById(ringType + 'StyleSwatches');
  if (!container || !ringConfig || !ringConfig.styles) return;
  
  var html = '';
  
  ringConfig.styles.forEach(function(style, index) {
    // Extract style code from label (e.g., "01 - Black" -> "01")
    var styleCodeMatch = (style.label || '').match(/^(\d{1,2})\s*[-:]/);
    var styleCode = styleCodeMatch ? (styleCodeMatch[1].length === 1 ? '0' + styleCodeMatch[1] : styleCodeMatch[1]) : (style.code || String(index + 1).padStart(2, '0'));
    var swatchFilename = (style.swatchImage || '').split('/').pop().split('?')[0].toLowerCase();
    
    html += '<button type="button" class="cj-style-swatch" ';
    html += 'data-style-index="' + index + '" ';
    html += 'data-style-id="' + (style.id || '') + '" ';
    html += 'data-style-label="' + escapeHtml(style.label || '') + '" ';
    html += 'data-style-code="' + styleCode + '" ';
    html += 'data-swatch-filename="' + swatchFilename + '" ';
    html += 'onclick="selectRamboStyle(\'' + ringType + '\', ' + index + ', this)">';
    
    if (style.swatchImage) {
      html += '<img src="' + style.swatchImage + '" alt="' + escapeHtml(style.label || 'Style ' + (index + 1)) + '" loading="lazy">';
    } else {
      html += '<span>' + escapeHtml(style.label || 'Style ' + (index + 1)) + '</span>';
    }
    
    html += '</button>';
  });
  
  container.innerHTML = html;
  
  // Store styles in state
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  cjState[ringKey].availableStyles = ringConfig.styles;
  
  console.log('Rendered', ringConfig.styles.length, 'RAMBO styles for', ringType);
}

// Select style - matches product page logic exactly
window.selectRamboStyle = function(ringType, styleIndex, btn) {
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  var ringConfig = cjState[ringKey].ringConfig;
  
  if (!ringConfig || !ringConfig.styles || styleIndex >= ringConfig.styles.length) {
    console.error('Invalid style selection');
    return;
  }
  
  var style = ringConfig.styles[styleIndex];
  var styleLabel = style.label || '';
  
  // Get style code from button data attribute (most reliable)
  var swatchStyleCode = btn.getAttribute('data-style-code') || '';
  var swatchFilename = btn.getAttribute('data-swatch-filename') || '';
  
  // Clean up style label: remove "Tungsten" from the text (matches product page)
  var cleanStyleLabel = styleLabel;
  if (cleanStyleLabel) {
    cleanStyleLabel = cleanStyleLabel.replace(/\s+Tungsten\s*/gi, ' ').trim();
    cleanStyleLabel = cleanStyleLabel.replace(/\s+/g, ' ');
  }
  
  // Store all style info in state (matches product page widgetState)
  cjState[ringKey].selectedStyleIndex = styleIndex;
  cjState[ringKey].selectedStyleCode = swatchStyleCode;
  cjState[ringKey].selectedStyleLabel = cleanStyleLabel;
  cjState[ringKey].style = cleanStyleLabel;
  cjState[ringKey].styleImage = style.swatchImage || '';
  
  // ALSO sync to window.cjState for checkout - KEEP existing price/name
  window.cjState = window.cjState || {};
  window.cjState[ringKey] = window.cjState[ringKey] || {};
  window.cjState[ringKey].style = cleanStyleLabel;
  window.cjState[ringKey].styleImage = style.swatchImage || '';
  window.cjState[ringKey].selectedStyleIndex = styleIndex;
  
  // Ensure price and productName are synced from local cjState
  if (cjState[ringKey].price && !window.cjState[ringKey].price) {
    window.cjState[ringKey].price = cjState[ringKey].price;
  }
  if (cjState[ringKey].productName && !window.cjState[ringKey].productName) {
    window.cjState[ringKey].productName = cjState[ringKey].productName;
  }
  if (cjState[ringKey].product && !window.cjState[ringKey].product) {
    window.cjState[ringKey].product = cjState[ringKey].product;
  }
  
  console.log('🎨 RAMBO STYLE SELECTED:', {
    ringKey: ringKey,
    style: cleanStyleLabel,
    image: style.swatchImage ? 'yes' : 'no',
    price: window.cjState[ringKey].price,
    productName: window.cjState[ringKey].productName
  });
  
  // Update UI - remove active from all, add to clicked
  var container = document.getElementById(ringType + 'StyleSwatches');
  container.querySelectorAll('.cj-style-swatch').forEach(function(s) {
    s.classList.remove('active');
    s.removeAttribute('data-active');
  });
  btn.classList.add('active');
  btn.setAttribute('data-active', 'true');
  
  // UPDATE SELECTED STYLE NAME DISPLAY (matches product page)
  var selectedNameEl = document.getElementById(ringType + 'StyleSelectedName');
  if (selectedNameEl) {
    selectedNameEl.textContent = cleanStyleLabel;
  }
  
  // Update preview image
  var previewImg = document.getElementById(ringType + 'PreviewImg');
  if (previewImg && style.swatchImage) {
    previewImg.src = style.swatchImage;
  }
  
  // Hide error
  var error = document.getElementById(ringType + 'StyleError');
  if (error) error.style.display = 'none';
  
  console.log('Selected RAMBO style:', cleanStyleLabel, 'Index:', styleIndex, 'Code:', swatchStyleCode);
  
  // Update nav button
  if (ringType === 'his') {
    window.updateStep2Button();
    celebrateAction('ring1Style');
  }
  if (ringType === 'her') {
    window.updateStep3Button();
    celebrateAction('ring2Style');
  }
  
  // Add visual celebration to swatch
  btn.classList.add('cj-ring-selected-celebrate');
};

// Old renderStyles and selectStyle removed - now using renderRamboStyles and selectRamboStyle which match product page exactly

// Reset selections when changing product
window.resetSelections = function(ringType) {
  // Reset size buttons
  var sizeContainer = document.getElementById(ringType + 'SizeButtons');
  if (sizeContainer) {
    sizeContainer.querySelectorAll('.cj-size-btn').forEach(function(btn) {
      btn.classList.remove('active');
    });
  }
  
  // Reset size hidden input
  var sizeInput = document.getElementById(ringType + 'Size');
  if (sizeInput) sizeInput.value = '';
  
  // Reset engraving
  var engravingInput = document.getElementById(ringType + 'Engraving');
  if (engravingInput) engravingInput.value = '';
  
  // Reset char count
  var charCount = document.getElementById(ringType + 'CharCount');
  if (charCount) charCount.textContent = '0';
  
  // Reset preview
  var previewText = document.getElementById(ringType + 'PreviewText');
  var placeholder = document.getElementById(ringType + 'PreviewPlaceholder');
  if (previewText) previewText.style.display = 'none';
  if (placeholder) placeholder.style.display = 'block';
}

// Legacy function for backward compatibility
window.selectProduct = function(ringType, product) {
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  cjState[ringKey].product = product;
  
  var previewContainer = document.getElementById(ringType + 'PreviewContainer');
  var img = product.images && product.images[0] ? product.images[0].src : '';
  var price = product.variants && product.variants[0] ? product.variants[0].price : '0';
  
  document.getElementById(ringType + 'PreviewImg').src = img;
  document.getElementById(ringType + 'PreviewName').textContent = product.title;
  document.getElementById(ringType + 'PreviewPrice').textContent = '$' + parseFloat(price).toFixed(2);
  
  previewContainer.style.display = 'block';
  document.getElementById(ringType + 'ProductsContainer').style.display = 'none';
  
  if (ringType === 'his') window.updateStep2Button();
  if (ringType === 'her') window.updateStep3Button();
};

// Clear selections
window.clearHisSelection = function() {
  // Reset all ring1 state (matches product page widgetState reset)
  cjState.ring1.product = null;
  cjState.ring1.ringConfig = null;
  cjState.ring1.defaultVariantId = null;
  cjState.ring1.selectedStyleIndex = -1;
  cjState.ring1.selectedStyleCode = '';
  cjState.ring1.selectedStyleLabel = '';
  cjState.ring1.style = '';
  cjState.ring1.styleImage = '';
  cjState.ring1.availableStyles = [];
  cjState.ring1.size = '';
  cjState.ring1.engraving = '';
  
  resetSelections('his');
  
  // Reset style swatches
  var styleContainer = document.getElementById('hisStyleSwatches');
  if (styleContainer) {
    styleContainer.innerHTML = '<p class="cj-style-placeholder"><svg viewBox="0 0 100 100" fill="none" style="width:40px;height:40px;opacity:0.3;"><circle cx="50" cy="50" r="38" stroke="#2C2C2C" stroke-width="10" fill="none"/></svg><br>Select a product to see styles</p>';
  }
  
  // Clear selected style name
  var selectedName = document.getElementById('hisStyleSelectedName');
  if (selectedName) selectedName.textContent = '';
  
  var preview = document.getElementById('hisPreviewContainer');
  if (preview) preview.style.display = 'none';
  var products = document.getElementById('hisProductsContainer');
  if (products) products.style.display = 'block';
  // Show filter toolbar when clearing selection
  var filterToolbar = document.getElementById('hisFilterToolbar');
  if (filterToolbar) filterToolbar.style.display = 'flex';
  window.updateStep2Button();
};

window.clearHerSelection = function() {
  // Reset all ring2 state (matches product page widgetState reset)
  cjState.ring2.product = null;
  cjState.ring2.ringConfig = null;
  cjState.ring2.defaultVariantId = null;
  cjState.ring2.selectedStyleIndex = -1;
  cjState.ring2.selectedStyleCode = '';
  cjState.ring2.selectedStyleLabel = '';
  cjState.ring2.style = '';
  cjState.ring2.styleImage = '';
  cjState.ring2.availableStyles = [];
  cjState.ring2.size = '';
  cjState.ring2.engraving = '';
  
  resetSelections('her');
  
  // Reset style swatches
  var styleContainer = document.getElementById('herStyleSwatches');
  if (styleContainer) {
    styleContainer.innerHTML = '<p class="cj-style-placeholder"><svg viewBox="0 0 100 100" fill="none" style="width:40px;height:40px;opacity:0.3;"><circle cx="50" cy="50" r="38" stroke="#2C2C2C" stroke-width="10" fill="none"/></svg><br>Select a product to see styles</p>';
  }
  
  // Clear selected style name
  var selectedName = document.getElementById('herStyleSelectedName');
  if (selectedName) selectedName.textContent = '';
  
  var preview = document.getElementById('herPreviewContainer');
  if (preview) preview.style.display = 'none';
  var products = document.getElementById('herProductsContainer');
  if (products) products.style.display = 'block';
  // Show filter toolbar when clearing selection
  var filterToolbar = document.getElementById('herFilterToolbar');
  if (filterToolbar) filterToolbar.style.display = 'flex';
  window.updateStep3Button();
};

// ========================================
// 🔥 RING 2 SEARCH PANEL FUNCTIONS
// ========================================

// Toggle Ring 2 search panel
window.toggleRing2Search = function() {
  var panel = document.getElementById('ring2SearchPanel');
  if (panel) {
    panel.classList.toggle('expanded');
    console.log('Ring 2 search panel toggled:', panel.classList.contains('expanded'));
  }
};

// Search for Ring 2 products
window.searchRing2Products = function() {
  var input = document.getElementById('ring2SearchInput');
  var searchTerm = input ? input.value.trim() : '';
  
  if (!searchTerm) {
    console.log('No search term entered');
    return;
  }
  
  console.log('🔍 Ring 2 searching for:', searchTerm);
  
  // Update query text
  var queryText = document.getElementById('herQueryText');
  if (queryText) {
    queryText.innerHTML = 'Showing results for: <strong>"' + escapeHtml(searchTerm) + '"</strong>';
  }
  
  // Clear any existing selection
  window.clearHerSelection();
  
  // Collapse search panel
  var panel = document.getElementById('ring2SearchPanel');
  if (panel) panel.classList.remove('expanded');
  
  // Show loading
  var container = document.getElementById('herProductsContainer');
  if (container) {
    container.innerHTML = '<div class="cj-loading cj-loading--premium"><div class="cj-loading__rings"><div class="cj-loading__ring cj-loading__ring--dark"></div><div class="cj-loading__ring cj-loading__ring--rose"></div></div><p class="cj-loading__text">Finding rings...</p></div>';
  }
  
  // Fetch products with the search term
  fetchRing2Products(searchTerm, '');
};

// Quick search for Ring 2
window.quickSearchRing2 = function(term) {
  console.log('🔥 Quick search Ring 2:', term);
  
  // Update query text
  var queryText = document.getElementById('herQueryText');
  if (queryText) {
    queryText.innerHTML = 'Showing results for: <strong>"' + escapeHtml(term) + '"</strong>';
  }
  
  // Clear any existing selection
  window.clearHerSelection();
  
  // Collapse search panel
  var panel = document.getElementById('ring2SearchPanel');
  if (panel) panel.classList.remove('expanded');
  
  // Show loading
  var container = document.getElementById('herProductsContainer');
  if (container) {
    container.innerHTML = '<div class="cj-loading cj-loading--premium"><div class="cj-loading__rings"><div class="cj-loading__ring cj-loading__ring--dark"></div><div class="cj-loading__ring cj-loading__ring--rose"></div></div><p class="cj-loading__text">Finding rings...</p></div>';
  }
  
  // Fetch products
  fetchRing2Products(term, '');
};

// Browse category for Ring 2
window.browseRing2Category = function(handle, name) {
  console.log('📁 Browse Ring 2 category:', handle, name);
  
  // Update query text
  var queryText = document.getElementById('herQueryText');
  if (queryText) {
    queryText.innerHTML = 'Browsing: <strong>' + escapeHtml(name) + '</strong>';
  }
  
  // Clear any existing selection
  window.clearHerSelection();
  
  // Collapse search panel
  var panel = document.getElementById('ring2SearchPanel');
  if (panel) panel.classList.remove('expanded');
  
  // Show loading
  var container = document.getElementById('herProductsContainer');
  if (container) {
    container.innerHTML = '<div class="cj-loading cj-loading--premium"><div class="cj-loading__rings"><div class="cj-loading__ring cj-loading__ring--dark"></div><div class="cj-loading__ring cj-loading__ring--rose"></div></div><p class="cj-loading__text">Finding rings...</p></div>';
  }
  
  // Fetch products
  fetchRing2Products('', handle);
};

// Store Ring 2 search products globally
window.ring2SearchProducts = [];

// Fetch Ring 2 products (separate from Ring 1)
function fetchRing2Products(searchQuery, categoryHandle) {
  var container = document.getElementById('herProductsContainer');
  if (!container) return;
  
  // Build API URL
  var collection = categoryHandle || 'all';
  var url = '/collections/' + collection + '/products.json?limit=50';
  
  console.log('Fetching Ring 2 products from:', url, 'Search:', searchQuery);
  
  fetch(url)
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to load products');
      return response.json();
    })
    .then(function(data) {
      var products = data.products || [];
      console.log('Loaded', products.length, 'products for Ring 2');
      
      // Filter by search if provided
      if (searchQuery) {
        var query = searchQuery.toLowerCase();
        products = products.filter(function(p) {
          return (p.title && p.title.toLowerCase().includes(query)) ||
                 (p.body_html && p.body_html.toLowerCase().includes(query)) ||
                 (p.tags && p.tags.some(function(t) { return t.toLowerCase().includes(query); })) ||
                 (p.product_type && p.product_type.toLowerCase().includes(query));
        });
        console.log('After search filter:', products.length, 'products');
      }
      
      // Store globally so we can select them
      window.ring2SearchProducts = products;
      
      // Also sync to cjState and cjProducts for selectProductById to work
      cjState.products = products;
      window.cjProducts = window.cjProducts || {};
      window.cjProducts.her = products;
      
      // Display products
      displayRing2Products(products, container);
    })
    .catch(function(error) {
      console.error('Error loading Ring 2 products:', error);
      container.innerHTML = '<div class="cj-error"><p>Unable to load products. Please try again.</p><button class="cj-btn" onclick="toggleRing2Search()">Try Different Search</button></div>';
    });
}

// Display Ring 2 products
function displayRing2Products(products, container) {
  if (!products || products.length === 0) {
    container.innerHTML = '<div class="cj-no-results"><svg viewBox="0 0 100 100" fill="none" style="width:60px;height:60px;opacity:0.3;margin-bottom:1rem;"><circle cx="50" cy="50" r="38" stroke="currentColor" stroke-width="8" fill="none"/></svg><p>No rings found matching your search.</p><button class="cj-btn cj-btn--secondary" onclick="toggleRing2Search()" style="margin-top:1rem;">Try Different Search</button></div>';
    return;
  }
  
  // Get wishlist - matches collection page
  var wishlist = [];
  try { wishlist = JSON.parse(localStorage.getItem('shopify_favorites') || '[]'); } catch(e) {}
  var wishlistIds = wishlist.map(function(w) { return String(typeof w === 'string' ? w : (w.productId || w.id)); });
  
  var html = '<div class="cj-products">';
  
  products.forEach(function(product, index) {
    var img = product.images && product.images[0] ? product.images[0].src : '';
    var price = product.variants && product.variants[0] ? product.variants[0].price : '0.00';
    var comparePrice = product.variants && product.variants[0] && product.variants[0].compare_at_price ? product.variants[0].compare_at_price : null;
    var productId = product.id || index;
    var safeTitle = (product.title || '').replace(/'/g, "\\'").replace(/"/g, '&quot;');
    var isWished = wishlistIds.indexOf(String(productId)) > -1;
    
    html += '<div class="cj-product" data-product-id="' + productId + '" style="position:relative;animation-delay: ' + (index * 0.05) + 's;">';
    
    // Heart wishlist icon - matches collection page
    html += '<div class="cj-product__wishlist' + (isWished ? ' active' : '') + '" onclick="event.stopPropagation();cjToggleWishlist(this,\'' + productId + '\',\'' + (product.handle || '') + '\',\'' + safeTitle + '\',\'' + img + '\',\'' + price + '\')">';
    html += '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    html += '</div>';
    
    html += '<div class="cj-product__click" onclick="selectProductById(\'her\', ' + index + ')" style="cursor:pointer;">';
    html += '<img class="cj-product__img" src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
    html += '<div class="cj-product__name">' + escapeHtml(product.title) + '</div>';
    html += '<div class="cj-product__price" style="display:flex;align-items:center;justify-content:center;gap:8px;">';
    if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
      html += '<span style="text-decoration:line-through;color:rgba(255,255,255,0.4);font-size:0.8rem;">$' + parseFloat(comparePrice).toFixed(2) + '</span>';
    }
    html += '<span style="color:#E8B4B8;">$' + parseFloat(price).toFixed(2) + '</span>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
  });
  
  html += '</div>';
  container.innerHTML = html;
  
  console.log('✅ Displayed', products.length, 'products for Ring 2');
}

// Add Enter key listener for Ring 2 search
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var ring2Input = document.getElementById('ring2SearchInput');
    if (ring2Input) {
      ring2Input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          searchRing2Products();
        }
      });
      console.log('✅ Ring 2 search Enter key listener attached');
    }
  }, 1000);
});

// Update navigation buttons - validates all required fields
// MADE GLOBAL so inline handlers can call them
window.updateStep2Button = function() {
  var btn = document.getElementById('step2Next');
  if (!btn) return;
  
  // Check STYLE from DOM
  var styleContainer = document.getElementById('hisStyleSwatches');
  var hasStyle = styleContainer && styleContainer.querySelector('.cj-style-swatch.active');
  
  // Check SIZE from DOM
  var sizeContainer = document.getElementById('hisSizeButtons');
  var hasSize = sizeContainer && sizeContainer.querySelector('.cj-size-btn.active');
  
  // Check ENGRAVING from input
  var engravingInput = document.getElementById('hisEngraving');
  var hasEngraving = engravingInput && engravingInput.value && engravingInput.value.trim().length > 0;
  
  // Check FONT (always has default)
  var fontTrigger = document.getElementById('hisFont-selected');
  var hasFont = fontTrigger && fontTrigger.textContent && fontTrigger.textContent.trim().length > 0;
  
  var isValid = hasStyle && hasSize && hasEngraving && hasFont;
    btn.disabled = !isValid;
  if (isValid) btn.removeAttribute('disabled');
    
    console.log('Ring 1 validation:', {
    hasStyle: !!hasStyle,
    hasSize: !!hasSize,
    hasEngraving: hasEngraving,
    hasFont: !!hasFont,
      valid: isValid
    });
};

window.updateStep3Button = function() {
  var btn = document.getElementById('step3Next');
  if (!btn) return;
  
  // Check STYLE from DOM
  var styleContainer = document.getElementById('herStyleSwatches');
  var hasStyle = styleContainer && styleContainer.querySelector('.cj-style-swatch.active');
  
  // Check SIZE from DOM
  var sizeContainer = document.getElementById('herSizeButtons');
  var hasSize = sizeContainer && sizeContainer.querySelector('.cj-size-btn.active');
  
  // Check ENGRAVING from input
  var engravingInput = document.getElementById('herEngraving');
  var hasEngraving = engravingInput && engravingInput.value && engravingInput.value.trim().length > 0;
  
  // Check FONT (always has default)
  var fontTrigger = document.getElementById('herFont-selected');
  var hasFont = fontTrigger && fontTrigger.textContent && fontTrigger.textContent.trim().length > 0;
  
  var isValid = hasStyle && hasSize && hasEngraving && hasFont;
    btn.disabled = !isValid;
  if (isValid) btn.removeAttribute('disabled');
    
    console.log('Ring 2 validation:', {
    hasStyle: !!hasStyle,
    hasSize: !!hasSize,
    hasEngraving: hasEngraving,
    hasFont: !!hasFont,
      valid: isValid
    });
};

// Aliases for local use
var updateStep2Button = window.updateStep2Button;
var updateStep3Button = window.updateStep3Button;

// Validate step before proceeding (show errors if needed)
function validateStep(ringType) {
  var ringKey = ringType === 'his' ? 'ring1' : 'ring2';
  var valid = true;
  
  // Check style
  if (!cjState[ringKey].style) {
    var styleError = document.getElementById(ringType + 'StyleError');
    if (styleError) styleError.style.display = 'block';
    valid = false;
  }
  
  // Check size
  if (!cjState[ringKey].size) {
    var sizeError = document.getElementById(ringType + 'SizeError');
    if (sizeError) sizeError.style.display = 'block';
    valid = false;
  }
  
  // Check engraving
  if (!cjState[ringKey].engraving || !cjState[ringKey].engraving.trim()) {
    var engravingError = document.getElementById(ringType + 'EngravingError');
    if (engravingError) engravingError.style.display = 'block';
    valid = false;
  }
  
  return valid;
}

// Update engraving preview with font and character count
function updateEngravingPreview(ringType, text) {
  var charCountEl = document.getElementById(ringType + 'CharCount');
  var previewTextEl = document.getElementById(ringType + 'PreviewText');
  var placeholderEl = document.getElementById(ringType + 'PreviewPlaceholder');
  var fontSelect = document.getElementById(ringType + 'Font');
  
  // Update character count
  if (charCountEl) {
    charCountEl.textContent = text.length;
    // Change color if near limit
    if (text.length >= 35) {
      charCountEl.style.color = '#e63946';
    } else if (text.length >= 30) {
      charCountEl.style.color = '#f4a261';
    } else {
      charCountEl.style.color = '';
    }
  }
  
  // Update preview
  if (previewTextEl && placeholderEl) {
    if (text.trim()) {
      previewTextEl.textContent = text;
      previewTextEl.style.display = 'block';
      previewTextEl.style.fontFamily = fontSelect ? fontSelect.value + ', serif' : 'Monotype Corsiva, serif';
      placeholderEl.style.display = 'none';
    } else {
      previewTextEl.style.display = 'none';
      placeholderEl.style.display = 'block';
    }
  }
}
  
  // Update checkout summary - ALWAYS reads from window.cjState (set by liquid JS) and DOM
window.updateCheckout = function() {
  console.log('🔥🔥🔥 UPDATING CHECKOUT 🔥🔥🔥');
  
  // Get ring states DIRECTLY from window.cjState (set by liquid inline JS)
  var ws = window.cjState || {};
  var r1 = ws.ring1 || {};
  var r2 = ws.ring2 || {};
  
  console.log('📊 WINDOW.CJSTATE:', {
    ring1: { price: r1.price, img: r1.styleImage ? 'yes' : 'no', name: r1.productName, style: r1.style, size: r1.size, engraving: r1.engraving, font: r1.font },
    ring2: { price: r2.price, img: r2.styleImage ? 'yes' : 'no', name: r2.productName, style: r2.style, size: r2.size, engraving: r2.engraving, font: r2.font }
  });
  
  // Get DOM elements for fallback
  var hisStyleEl = document.getElementById('hisStyle');
  var hisSizeEl = document.getElementById('hisSize');
  var hisEngravingEl = document.getElementById('hisEngraving');
  var hisFontEl = document.getElementById('hisFont-selected');
  var hisPreviewImg = document.getElementById('hisPreviewImg');
  var hisPreviewPrice = document.getElementById('hisPreviewPrice');
  var hisPreviewName = document.getElementById('hisPreviewName');
  
  var herStyleEl = document.getElementById('herStyle');
  var herSizeEl = document.getElementById('herSize');
  var herEngravingEl = document.getElementById('herEngraving');
  var herFontEl = document.getElementById('herFont-selected');
  var herPreviewImg = document.getElementById('herPreviewImg');
  var herPreviewPrice = document.getElementById('herPreviewPrice');
  var herPreviewName = document.getElementById('herPreviewName');
  
  // ========== RING 1 DATA - window.cjState first, then DOM fallback ==========
  var ring1Price = r1.price ? parseFloat(r1.price) : 0;
  if (!ring1Price && r1.product && r1.product.variants && r1.product.variants[0]) {
    ring1Price = parseFloat(r1.product.variants[0].price) || 0;
  }
  if (!ring1Price && hisPreviewPrice && hisPreviewPrice.textContent) {
    ring1Price = parseFloat(hisPreviewPrice.textContent.replace(/[^0-9.]/g, '')) || 0;
  }
  
  var ring1Img = r1.styleImage || '';
  if (!ring1Img && r1.product && r1.product.images && r1.product.images[0]) {
    ring1Img = r1.product.images[0].src || r1.product.images[0];
  }
  if (!ring1Img && hisPreviewImg && hisPreviewImg.src && hisPreviewImg.src.startsWith('http')) {
    ring1Img = hisPreviewImg.src;
  }
  
  var ring1Name = r1.productName || '';
  if (!ring1Name && r1.product && r1.product.title) ring1Name = r1.product.title;
  if (!ring1Name && hisPreviewName && hisPreviewName.textContent) ring1Name = hisPreviewName.textContent.trim();
  if (!ring1Name) ring1Name = 'Ring 1';
  
  var ring1Style = r1.style || (hisStyleEl && hisStyleEl.value) || '';
  var ring1Size = r1.size || (hisSizeEl && hisSizeEl.value) || '';
  var ring1Engraving = r1.engraving || (hisEngravingEl && hisEngravingEl.value) || '';
  var ring1Font = r1.font || (hisFontEl && hisFontEl.textContent && hisFontEl.textContent.trim()) || 'Monotype Corsiva';
  
  // ========== RING 2 DATA - window.cjState first, then DOM fallback ==========
  var ring2Price = r2.price ? parseFloat(r2.price) : 0;
  if (!ring2Price && r2.product && r2.product.variants && r2.product.variants[0]) {
    ring2Price = parseFloat(r2.product.variants[0].price) || 0;
  }
  if (!ring2Price && herPreviewPrice && herPreviewPrice.textContent) {
    ring2Price = parseFloat(herPreviewPrice.textContent.replace(/[^0-9.]/g, '')) || 0;
  }
  
  var ring2Img = r2.styleImage || '';
  if (!ring2Img && r2.product && r2.product.images && r2.product.images[0]) {
    ring2Img = r2.product.images[0].src || r2.product.images[0];
  }
  if (!ring2Img && herPreviewImg && herPreviewImg.src && herPreviewImg.src.startsWith('http')) {
    ring2Img = herPreviewImg.src;
  }
  
  var ring2Name = r2.productName || '';
  if (!ring2Name && r2.product && r2.product.title) ring2Name = r2.product.title;
  if (!ring2Name && herPreviewName && herPreviewName.textContent) ring2Name = herPreviewName.textContent.trim();
  if (!ring2Name) ring2Name = 'Ring 2';
  
  var ring2Style = r2.style || (herStyleEl && herStyleEl.value) || '';
  var ring2Size = r2.size || (herSizeEl && herSizeEl.value) || '';
  var ring2Engraving = r2.engraving || (herEngravingEl && herEngravingEl.value) || '';
  var ring2Font = r2.font || (herFontEl && herFontEl.textContent && herFontEl.textContent.trim()) || 'Monotype Corsiva';
  
  console.log('📦 FINAL DATA:', {
    ring1: { price: ring1Price, img: ring1Img ? 'YES' : 'NO', name: ring1Name, style: ring1Style, size: ring1Size, engraving: ring1Engraving, font: ring1Font },
    ring2: { price: ring2Price, img: ring2Img ? 'YES' : 'NO', name: ring2Name, style: ring2Style, size: ring2Size, engraving: ring2Engraving, font: ring2Font }
  });
  
  // Get partner names
  var name1 = (window.cjUserNames && window.cjUserNames.name1) || 'Partner 1';
  var name2 = (window.cjUserNames && window.cjUserNames.name2) || 'Partner 2';
  
  // Ring 1 summary - use placeholder if no image
  var placeholder = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Ccircle cx="50" cy="50" r="38" stroke="%23666" stroke-width="8" fill="none"/%3E%3C/svg%3E';
  var el;
  el = document.getElementById('summaryHisImg'); if (el) el.src = ring1Img || placeholder;
  el = document.getElementById('summaryHisIconImg'); if (el) el.src = ring1Img || placeholder;
  el = document.getElementById('summaryHisLabel'); if (el) el.textContent = name1 + "'s Ring";
  el = document.getElementById('summaryHisName'); if (el) el.textContent = ring1Name || 'Selected Ring';
  el = document.getElementById('summaryHisStyle'); if (el) el.textContent = ring1Style || 'Default Style';
  el = document.getElementById('summaryHisSize'); if (el) el.textContent = ring1Size || 'Not selected';
  el = document.getElementById('summaryHisEngraving'); 
  if (el) {
    if (ring1Engraving) {
      el.textContent = '"' + ring1Engraving + '"';
      el.style.fontFamily = ring1Font + ', serif';
      el.style.display = 'block';
    } else {
      el.textContent = 'No engraving';
      el.style.fontFamily = '';
    }
  }
  el = document.getElementById('summaryHisFont'); if (el) el.textContent = 'Font: ' + (ring1Font || 'Default');
  el = document.getElementById('summaryHisPrice'); if (el) el.textContent = '$' + parseFloat(ring1Price || 0).toFixed(2);
  
  // Ring 2 summary - use placeholder if no image
  el = document.getElementById('summaryHerImg'); if (el) el.src = ring2Img || placeholder;
  el = document.getElementById('summaryHerIconImg'); if (el) el.src = ring2Img || placeholder;
  el = document.getElementById('summaryHerLabel'); if (el) el.textContent = name2 + "'s Ring";
  el = document.getElementById('summaryHerName'); if (el) el.textContent = ring2Name || 'Selected Ring';
  el = document.getElementById('summaryHerStyle'); if (el) el.textContent = ring2Style || 'Default Style';
  el = document.getElementById('summaryHerSize'); if (el) el.textContent = ring2Size || 'Not selected';
  el = document.getElementById('summaryHerEngraving'); 
  if (el) {
    if (ring2Engraving) {
      el.textContent = '"' + ring2Engraving + '"';
      el.style.fontFamily = ring2Font + ', serif';
      el.style.display = 'block';
    } else {
      el.textContent = 'No engraving';
      el.style.fontFamily = '';
    }
  }
  el = document.getElementById('summaryHerFont'); if (el) el.textContent = 'Font: ' + (ring2Font || 'Default');
  el = document.getElementById('summaryHerPrice'); if (el) el.textContent = '$' + parseFloat(ring2Price || 0).toFixed(2);
  
  // Pricing calculations
  var subtotal = parseFloat(ring1Price) + parseFloat(ring2Price);
  var discount = subtotal * 0.1;
  var total = subtotal - discount;
  
  // Update pricing labels with names
  el = document.getElementById('pricingHisLabel'); if (el) el.textContent = name1 + "'s Ring";
  el = document.getElementById('pricingHerLabel'); if (el) el.textContent = name2 + "'s Ring";
  
  // Update pricing row images (ring thumbnails)
  el = document.getElementById('pricingHisImg'); if (el) el.src = ring1Img || placeholder;
  el = document.getElementById('pricingHerImg'); if (el) el.src = ring2Img || placeholder;
  
  // Update pricing values
  el = document.getElementById('pricingHis'); if (el) el.textContent = '$' + parseFloat(ring1Price).toFixed(2);
  el = document.getElementById('pricingHer'); if (el) el.textContent = '$' + parseFloat(ring2Price).toFixed(2);
  el = document.getElementById('pricingDiscount'); if (el) el.textContent = '-$' + discount.toFixed(2);
  el = document.getElementById('pricingOriginal'); if (el) el.textContent = '$' + subtotal.toFixed(2);
  el = document.getElementById('pricingTotal'); if (el) el.textContent = '$' + total.toFixed(2);
  
  console.log('💰 Pricing updated:', { ring1Price, ring2Price, subtotal, discount, total, ring1Img: !!ring1Img, ring2Img: !!ring2Img });
  
  // Update infinity animation images - use placeholder if no image
  var infRing1 = document.getElementById('infinityRing1Img');
  var infRing2 = document.getElementById('infinityRing2Img');
  if (infRing1) { infRing1.src = ring1Img || placeholder; }
  if (infRing2) { infRing2.src = ring2Img || placeholder; }
  
  // Update infinity animation labels with names
  var infLabel1 = document.getElementById('infinityLabel1');
  var infLabel2 = document.getElementById('infinityLabel2');
  if (infLabel1) infLabel1.textContent = name1 + "'s Ring";
  if (infLabel2) infLabel2.textContent = name2 + "'s Ring";
  
  // Update engraving text in animation
  var infEng1 = document.getElementById('infinityEngraving1');
  var infEng2 = document.getElementById('infinityEngraving2');
  if (infEng1) { infEng1.textContent = ring1Engraving; infEng1.style.fontFamily = ring1Font + ', serif'; }
  if (infEng2) { infEng2.textContent = ring2Engraving; infEng2.style.fontFamily = ring2Font + ', serif'; }
  
  console.log('✅ Checkout update complete');
}

// Sync state from DOM inputs AND window.cjState/cjProducts
window.syncStateFromDOM = function() {
  console.log('🔄 Syncing state from DOM and window.cjState...');
  
  // Ensure cjState has ring objects
  cjState.ring1 = cjState.ring1 || {};
  cjState.ring2 = cjState.ring2 || {};
  
  // ========== RING 1 SYNC ==========
  // Sync ALL data from window.cjState
  if (window.cjState && window.cjState.ring1) {
    if (!cjState.ring1.product && window.cjState.ring1.product) {
      cjState.ring1.product = window.cjState.ring1.product;
    }
    if (!cjState.ring1.price && window.cjState.ring1.price) {
      cjState.ring1.price = window.cjState.ring1.price;
    }
    if (!cjState.ring1.productName && window.cjState.ring1.productName) {
      cjState.ring1.productName = window.cjState.ring1.productName;
    }
    if (!cjState.ring1.styleImage && window.cjState.ring1.styleImage) {
      cjState.ring1.styleImage = window.cjState.ring1.styleImage;
    }
    if (!cjState.ring1.style && window.cjState.ring1.style) {
      cjState.ring1.style = window.cjState.ring1.style;
    }
  }
  
  // If still no product, try window.cjProducts
  if (!cjState.ring1.product && window.cjProducts && window.cjProducts.his && window.cjProducts.his.length > 0) {
    cjState.ring1.product = window.cjProducts.his[0];
    var p = window.cjProducts.his[0];
    if (!cjState.ring1.price && p.variants && p.variants[0]) {
      cjState.ring1.price = p.variants[0].price;
    }
    if (!cjState.ring1.productName && p.title) {
      cjState.ring1.productName = p.title;
    }
    if (!cjState.ring1.styleImage && p.images && p.images[0]) {
      cjState.ring1.styleImage = p.images[0].src || p.images[0];
    }
  }
  
  // ========== RING 2 SYNC ==========
  if (window.cjState && window.cjState.ring2) {
    if (!cjState.ring2.product && window.cjState.ring2.product) {
      cjState.ring2.product = window.cjState.ring2.product;
    }
    if (!cjState.ring2.price && window.cjState.ring2.price) {
      cjState.ring2.price = window.cjState.ring2.price;
    }
    if (!cjState.ring2.productName && window.cjState.ring2.productName) {
      cjState.ring2.productName = window.cjState.ring2.productName;
    }
    if (!cjState.ring2.styleImage && window.cjState.ring2.styleImage) {
      cjState.ring2.styleImage = window.cjState.ring2.styleImage;
    }
    if (!cjState.ring2.style && window.cjState.ring2.style) {
      cjState.ring2.style = window.cjState.ring2.style;
    }
  }
  
  // If still no product, try window.cjProducts
  if (!cjState.ring2.product && window.cjProducts && window.cjProducts.her && window.cjProducts.her.length > 0) {
    cjState.ring2.product = window.cjProducts.her[0];
    var p2 = window.cjProducts.her[0];
    if (!cjState.ring2.price && p2.variants && p2.variants[0]) {
      cjState.ring2.price = p2.variants[0].price;
    }
    if (!cjState.ring2.productName && p2.title) {
      cjState.ring2.productName = p2.title;
    }
    if (!cjState.ring2.styleImage && p2.images && p2.images[0]) {
      cjState.ring2.styleImage = p2.images[0].src || p2.images[0];
    }
  }
  
  // Sync form values from DOM
  var hisSize = document.getElementById('hisSize');
  var hisEngraving = document.getElementById('hisEngraving');
  var hisFont = document.getElementById('hisFont-selected');
  var hisStyle = document.getElementById('hisStyle');
  
  if (hisSize && hisSize.value) cjState.ring1.size = hisSize.value;
  if (hisEngraving && hisEngraving.value) cjState.ring1.engraving = hisEngraving.value;
  if (hisFont && hisFont.textContent) cjState.ring1.font = hisFont.textContent;
  if (hisStyle && hisStyle.value) cjState.ring1.style = hisStyle.value;
  
  var herSize = document.getElementById('herSize');
  var herEngraving = document.getElementById('herEngraving');
  var herFont = document.getElementById('herFont-selected');
  var herStyle = document.getElementById('herStyle');
  
  if (herSize && herSize.value) cjState.ring2.size = herSize.value;
  if (herEngraving && herEngraving.value) cjState.ring2.engraving = herEngraving.value;
  if (herFont && herFont.textContent) cjState.ring2.font = herFont.textContent;
  if (herStyle && herStyle.value) cjState.ring2.style = herStyle.value;
  
  console.log('✅ STATE AFTER SYNC:', {
    ring1: { 
      hasProduct: !!cjState.ring1.product, 
      price: cjState.ring1.price,
      productName: cjState.ring1.productName,
      hasImage: !!cjState.ring1.styleImage,
      size: cjState.ring1.size
    },
    ring2: { 
      hasProduct: !!cjState.ring2.product, 
      price: cjState.ring2.price,
      productName: cjState.ring2.productName,
      hasImage: !!cjState.ring2.styleImage,
      size: cjState.ring2.size
    }
  });
}

// Add both rings to cart - EXACT COPY OF PRODUCT PAGE LOGIC
window.addToCart = async function() {
  var btn = document.getElementById('finalAddBtn');
  if (!btn) return;
  
  btn.classList.add('loading');
  var btnText = btn.querySelector('.cj-final-btn__text');
  if (btnText) btnText.textContent = 'Adding to Cart...';
  
  try {
    // Add Ring 1
    await addRingToCart('ring1', cjState.ring1);
    
    // Add Ring 2
    await addRingToCart('ring2', cjState.ring2);
    
    // SUCCESS! MEGA CELEBRATION!
    btn.classList.remove('loading');
    btn.classList.add('success');
    if (btnText) btnText.textContent = 'Both Rings Added!';
    
    // EPIC FINAL CELEBRATION
    triggerCelebration('confetti', 'high');
    triggerCelebration('burst');
    showMilestone("Congratulations! Your rings are on their way!");
    
    // Extra confetti burst
    setTimeout(function() {
      triggerCelebration('confetti', 'high');
    }, 500);
    
    // Redirect to cart with discount code auto-applied
    setTimeout(function() {
      window.location.href = '/cart?discount=COUPLES10';
    }, 2000);
    
  } catch (err) {
    console.error('Cart error:', err);
    btn.classList.remove('loading');
    if (btnText) {
      btnText.textContent = 'Error: ' + (err.message || 'Try Again');
      setTimeout(function() {
        btnText.textContent = 'Complete Your Journey - Add Both to Cart';
      }, 3000);
    }
  }
};

// Add single ring to cart - MATCHES PRODUCT PAGE handleCustomAddToCart EXACTLY
async function addRingToCart(ringLabel, ringState) {
  // Sync from DOM first
  syncStateFromDOM();
  
  var ringType = ringLabel === 'ring1' ? 'his' : 'her';
  
  // Make sure we have the product - check multiple sources
  if (!ringState.product) {
    // Try window.cjProducts
    if (window.cjProducts && window.cjProducts[ringType]) {
      // Find the first product or the one that was selected
      ringState.product = window.cjProducts[ringType][0];
    }
  }
  
  var ringConfig = ringState.ringConfig;
  var styleIndex = ringState.selectedStyleIndex;
  var selectedSizeCode = ringState.size;
  
  // Get engraving from state or DOM
  var engravingInput = document.getElementById(ringType + 'Engraving');
  var engraving = ringState.engraving || (engravingInput ? engravingInput.value : '');
  
  // Validate size - get from DOM if missing
  if (!selectedSizeCode) {
    var sizeInput = document.getElementById(ringType + 'Size');
    selectedSizeCode = sizeInput ? sizeInput.value : '';
  }
  
  if (!selectedSizeCode) {
    throw new Error('Please select a ring size for ' + ringLabel);
  }
  
  if (!engraving || !engraving.trim()) {
    throw new Error('Please enter engraving text for ' + ringLabel);
  }
  
  // If no ringConfig (fallback mode), use simple add to cart
  if (!ringConfig || !ringConfig.styles) {
    console.log('Using simple add to cart for', ringLabel);
    return addRingToCartSimple(ringLabel, ringState, selectedSizeCode, engraving);
  }
  
  // Validate style selection
  if (styleIndex === undefined || styleIndex === null || styleIndex < 0) {
    console.log('No style index, using simple add to cart for', ringLabel);
    return addRingToCartSimple(ringLabel, ringState, selectedSizeCode, engraving);
  }
  
  var style = ringConfig.styles[styleIndex];
  if (!style) {
    return addRingToCartSimple(ringLabel, ringState, selectedSizeCode, engraving);
  }
  
  var styleLabel = style.label || '';
  
  // Get style code (matches product page logic)
  var swatchStyleCode = ringState.selectedStyleCode || '';
  
  // Find variant from style.variants that matches selected size (EXACT MATCH TO PRODUCT PAGE)
  var variant = null;
  if (style.variants && style.variants.length > 0) {
    variant = style.variants.find(function(v) { return v.sizeCode === selectedSizeCode; });
  }
  
  // Use variant's shopifyVariantId if available, otherwise default (EXACT MATCH TO PRODUCT PAGE)
  var variantIdToUse = ringState.defaultVariantId || ringState.product.variants[0].id;
  if (variant && variant.shopifyVariantId) {
    var shopifyVariantIdStr = String(variant.shopifyVariantId).trim();
    var shopifyVariantIdNum = Number(shopifyVariantIdStr);
    if (shopifyVariantIdStr && !isNaN(shopifyVariantIdNum) && shopifyVariantIdNum > 0) {
      variantIdToUse = String(shopifyVariantIdNum);
    }
  }
  
  // Get SKU from variant (EXACT MATCH TO PRODUCT PAGE: variant.sku)
  var variantSku = variant ? (variant.sku || '') : '';
  
  // Clean size label (matches product page cleanRingSizeLabel)
  var sizeLabel = selectedSizeCode;
  sizeLabel = sizeLabel.replace(/\s*US\s*/gi, ' ').trim();
  sizeLabel = sizeLabel.replace(/\s*\([^)]*\)\s*/g, ' ').trim();
  var numberMatch = sizeLabel.match(/(\d+\.?\d*)/);
  if (numberMatch) sizeLabel = numberMatch[1];
  
  // Clean style label: remove "Tungsten" (matches product page)
  var cleanStyleLabel = styleLabel;
  if (cleanStyleLabel) {
    cleanStyleLabel = cleanStyleLabel.replace(/\s+Tungsten\s*/gi, ' ').trim();
    cleanStyleLabel = cleanStyleLabel.replace(/\s+/g, ' ');
  }
  
  // Get engraving info
  var engravingText = ringState.engraving.trim();
  var engravingFont = ringState.font || 'Monotype Corsiva';
  
  // Get person's name for this ring
  var personName = '';
  if (ringLabel === 'ring1') {
    personName = (window.cjUserNames && window.cjUserNames.name1) || (typeof cjUserNames !== 'undefined' && cjUserNames.name1) || 'Partner 1';
  } else {
    personName = (window.cjUserNames && window.cjUserNames.name2) || (typeof cjUserNames !== 'undefined' && cjUserNames.name2) || 'Partner 2';
  }

  // Get SKU - try multiple sources
  var finalSku = variantSku;
  if (!finalSku && ringState.product && ringState.product.variants && ringState.product.variants[0]) {
    finalSku = ringState.product.variants[0].sku || '';
  }
  if (!finalSku) finalSku = 'N/A';

  // Make sure style label is not empty
  var finalStyleLabel = cleanStyleLabel || ringState.style || styleLabel || 'Default Style';
  
  // Build properties object - EXACT MATCH TO PRODUCT PAGE
  var properties = {
    'For': personName + "'s Ring",
    'Ring Style': finalStyleLabel,
    'Ring Size': sizeLabel,
    'Ring SKU': finalSku,
    'Inside Engraving Text': engravingText,
    'Engraving Font': engravingFont,
    'Couples Discount': '10% Off Applied',
    '_styleIndex': String(styleIndex),
    '_bundle': 'couples-ring-set',
    '_ring_number': ringLabel === 'ring1' ? 'Ring 1' : 'Ring 2',
    '_person_name': personName,
    '_discount_code': 'COUPLES10'
  };

  console.log('🛒 Cart properties for ' + ringLabel + ':', properties);
  
  // Find product image URL (matches product page logic)
  var normalizedStyleNum = null;
  if (swatchStyleCode) {
    var codeMatch = swatchStyleCode.match(/(\d{1,2})/);
    if (codeMatch) {
      normalizedStyleNum = codeMatch[1].length === 1 ? '0' + codeMatch[1] : codeMatch[1];
    }
  }
  if (!normalizedStyleNum && styleLabel) {
    var labelMatch = styleLabel.match(/^(\d{1,2})\s*[--:]/);
    if (labelMatch) {
      normalizedStyleNum = labelMatch[1].length === 1 ? '0' + labelMatch[1] : labelMatch[1];
    }
  }
  if (!normalizedStyleNum) {
    var styleNum = styleIndex + 1;
    normalizedStyleNum = styleNum < 10 ? '0' + styleNum : String(styleNum);
  }
  
  // Use swatch image or product image
  var productImageUrl = style.swatchImage || (ringState.product.images[0] ? ringState.product.images[0].src : '');
  
  if (productImageUrl) {
    if (productImageUrl.startsWith('//')) {
      productImageUrl = 'https:' + productImageUrl;
    }
    properties['_image'] = productImageUrl;
  }
  
  console.log('🛒🛒🛒 ADDING ' + ringLabel.toUpperCase() + ' TO CART 🛒🛒🛒');
  console.log('Variant ID:', variantIdToUse);
  console.log('ALL PROPERTIES:', JSON.stringify(properties, null, 2));
  
  // SAVE TO LOCALSTORAGE SO WE CAN SEE ON CART PAGE
  var debugLogs = JSON.parse(localStorage.getItem('cartDebugLogs') || '[]');
  debugLogs.push({
    ring: ringLabel,
    properties: properties,
    time: new Date().toISOString()
  });
  localStorage.setItem('cartDebugLogs', JSON.stringify(debugLogs));
  
  var requestBody = {
    id: variantIdToUse,
    quantity: 1,
    properties: properties
  };
  console.log('FULL REQUEST BODY:', JSON.stringify(requestBody, null, 2));
  
  // Add to cart via AJAX - EXACT MATCH TO PRODUCT PAGE
  var response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });
  
  var responseData = await response.clone().json();
  console.log('CART RESPONSE:', responseData);
  
  if (!response.ok) {
    var text = await response.text();
    var err = {};
    try { err = JSON.parse(text); } catch(e) {}
    
    var errorMessage = err.description || err.message;
    if (!errorMessage) {
      if (response.status === 409 || response.status === 422) {
        errorMessage = 'Item is likely out of stock';
      } else {
        errorMessage = 'HTTP ' + response.status;
      }
    }
    throw new Error(ringLabel + ': ' + errorMessage);
  }
  
  return response.json();
}

// Simple add to cart fallback (when ringConfig is not available)
async function addRingToCartSimple(ringLabel, ringState, selectedSizeCode, engraving) {
  var product = ringState.product;
  
  // Try to find product from other sources if not in state
  if (!product) {
    var ringType = ringLabel === 'ring1' ? 'his' : 'her';
    // Check window.cjProducts
    if (window.cjProducts && window.cjProducts[ringType] && window.cjProducts[ringType].length > 0) {
      product = window.cjProducts[ringType][0]; // Use first product if no specific selection
    }
  }
  
  if (!product) {
    throw new Error('No product selected for ' + ringLabel + '. Please go back and select a ring.');
  }
  
  var variant = product.variants && product.variants[0] ? product.variants[0] : null;
  var variantId = variant ? variant.id : null;
  var variantSku = variant ? (variant.sku || 'N/A') : 'N/A';
  
  if (!variantId) {
    throw new Error('No variant found for ' + ringLabel);
  }
  
  var ringType = ringLabel === 'ring1' ? 'his' : 'her';
  var fontEl = document.getElementById(ringType + 'Font-selected');
  var styleEl = document.getElementById(ringType + 'Style');
  
  var engravingFont = ringState.font || (fontEl ? fontEl.textContent : 'Monotype Corsiva');
  var styleLabel = ringState.style || (styleEl ? styleEl.value : 'Default');
  
  // Clean size label
  var sizeLabel = selectedSizeCode;
  sizeLabel = sizeLabel.replace(/\s*US\s*/gi, ' ').trim();
  var numberMatch = sizeLabel.match(/(\d+\.?\d*)/);
  if (numberMatch) sizeLabel = numberMatch[1];
  
  // Get person's name for this ring
  var personName = '';
  if (ringLabel === 'ring1') {
    personName = (window.cjUserNames && window.cjUserNames.name1) || (typeof cjUserNames !== 'undefined' && cjUserNames.name1) || 'Partner 1';
      } else {
    personName = (window.cjUserNames && window.cjUserNames.name2) || (typeof cjUserNames !== 'undefined' && cjUserNames.name2) || 'Partner 2';
  }

  // Make sure values are not empty
  var finalStyleLabel = styleLabel || ringState.style || 'Default Style';
  var finalSku = variantSku || 'N/A';

  var properties = {
    'For': personName + "'s Ring",
    'Ring Style': finalStyleLabel,
    'Ring Size': sizeLabel,
    'Ring SKU': finalSku,
    'Inside Engraving Text': engraving.trim(),
    'Engraving Font': engravingFont,
    'Couples Discount': '10% Off Applied',
    '_bundle': 'couples-ring-set',
    '_ring_number': ringLabel === 'ring1' ? 'Ring 1' : 'Ring 2',
    '_person_name': personName,
    '_discount_code': 'COUPLES10'
  };

  console.log('🛒 Cart properties (simple) for ' + ringLabel + ':', properties);
  
  // Add image if available
  var imageUrl = ringState.styleImage || (product.images && product.images[0] ? product.images[0].src : '');
  if (imageUrl) {
    if (imageUrl.startsWith('//')) imageUrl = 'https:' + imageUrl;
    properties['_image'] = imageUrl;
  }
  
  console.log('🛒🛒🛒 ADDING ' + ringLabel.toUpperCase() + ' TO CART (SIMPLE) 🛒🛒🛒');
  console.log('Variant ID:', variantId);
  console.log('ALL PROPERTIES:', JSON.stringify(properties, null, 2));
  
  // SAVE TO LOCALSTORAGE SO WE CAN SEE ON CART PAGE
  var debugLogs = JSON.parse(localStorage.getItem('cartDebugLogs') || '[]');
  debugLogs.push({
    ring: ringLabel,
    properties: properties,
    time: new Date().toISOString()
  });
  localStorage.setItem('cartDebugLogs', JSON.stringify(debugLogs));
  
  var requestBody = {
    id: variantId,
    quantity: 1,
    properties: properties
  };
  console.log('FULL REQUEST BODY:', JSON.stringify(requestBody, null, 2));

  var response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestBody)
  });
  
  var responseData = await response.clone().json();
  console.log('CART RESPONSE:', responseData);
  
  if (!response.ok) {
    var text = await response.text();
    var err = {};
    try { err = JSON.parse(text); } catch(e) {}
    var errorMessage = err.description || err.message || 'Error adding to cart';
    throw new Error(ringLabel + ': ' + errorMessage);
  }
  
  return response.json();
}

// Escape HTML for safety
function escapeHtml(str) {
  if (!str) return '';
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

// Add pulse animation for button feedback
var style = document.createElement('style');
style.textContent = '@keyframes cjPulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }';
document.head.appendChild(style);

console.log('Couples Builder script loaded');
